// French dictionary. Falls back to es for any missing key.
export const fr = {
  "notif_title": "Centre de notifications", "notif_mark_read": "Tout marquer comme lu", "notif_clear": "Vider l'historique", "notif_empty": "Aucune notification pour l'instant", "notif_k_all": "Toutes", "notif_k_admin": "Orbit", "notif_k_wholesale": "Grossistes", "notif_k_billing": "Abonnement", "notif_k_stock": "Stock", "notif_stock_summary": "{n} produit(s) en stock bas", "notif_stock_item": "Stock bas : {name} ({n})",
  "tpl_manage": "Modèles", "tpl_title": "Modèles d'annonce (ES / AR / FR)", "tpl_desc": "Enregistrez des avis réutilisables dans les trois langues. Choisir un modèle insère les versions disponibles ; ES/AR/FR n'insère que cette langue.", "tpl_empty": "Aucun modèle pour l'instant.", "tpl_new": "Nouveau modèle", "tpl_name": "Nom du modèle",
  "orders": "Commandes fournisseurs", "order": "Commande", "new_order": "Nouvelle commande", "orders_desc": "Préparez la commande de marchandise que le fournisseur livrera au magasin ; à la réception elle entre en stock.", "purchase_order": "Commande fournisseur", "add_low_stock": "Ajouter les produits en stock bas", "add_all_products": "Ajouter tous les produits", "est_cost": "coût estimé", "order_sent": "Envoyée", "order_received": "Reçue", "order_send": "Envoyer WhatsApp", "order_receive": "Réceptionner", "order_receive_hint": "Ajustez les quantités et coûts réellement reçus ; l'achat sera créé et le stock mis à jour.", "order_receive_confirm": "Confirmer la réception", "save_order": "Enregistrer la commande", "order_saved": "Commande enregistrée", "orders_open": "Commandes ouvertes", "no_orders": "Aucune commande", "order_needs_items": "Ajoutez au moins un produit", "order_due": "Date de livraison", "order_deposit": "Acompte", "order_pending": "En attente", "order_ready": "Prête", "order_delivered": "Livrée", "order_cancelled": "Annulée", "order_deliver": "Livrer et encaisser", "order_cancel_confirm": "Annuler cette commande ?", "act_order.upsert": "Commande",
  "exp_repairs": "Réparations", "exp_site_work": "Travail sur site / à domicile", "exp_commission": "Commissions", "exp_damages": "Dommages et casse", "exp_incentives": "Primes aux travailleurs", "exp_misc": "Divers", "exp_payee": "Payé à", "exp_payee_ph": "Transporteur, technicien, entreprise…", "exp_worker": "Travailleur",
  "co_delivery_settle": "Livraison · solder le reste", "co_delivery_settle_hint": "Pour livrer, tout le montant restant doit être appliqué : espèces, carte, virement ou crédit client.", "co_delivery_full": "Tout le montant restant doit être appliqué pour livrer", "co_credit_needs_customer": "Le crédit nécessite un client enregistré", "co_credit_hint": "Le montant à crédit est porté automatiquement au compte du client",
  "co_sheet": "Fiche de commande", "co_payment_receipt": "Reçu de paiement", "co_sign_customer": "Signature du client", "co_sign_hint": "Conforme aux mesures, au design et aux conditions", "co_sign_shop": "Pour le magasin",
  "co_add_method": "Ajouter un mode de paiement", "co_deposit_hint": "peut être réparti sur plusieurs modes de paiement", "co_paid": "Encaissé", "co_collect": "Encaisser le reste", "co_collect_hint": "encaissez le reste depuis la fiche de commande", "co_balance_payment": "Solde commande sur mesure", "co_remaining_after": "Restera à payer", "co_over_pay": "Le montant dépasse le solde", "amount_required": "Indiquez un montant",
  "bcast_btn": "Message à tous", "bcast_title": "Message à plusieurs appareils", "bcast_target": "Cible", "bcast_all_shops": "Tous les magasins", "bcast_only_online": "Appareils connectés seulement (12 dernières min)", "bcast_recipients": "Destinataires : {n}", "bcast_sent": "Message envoyé à {n} appareil(s)",
  "send": "Envoyer", "close": "Fermer", "device_cmd_message": "Message", "device_msg_desc": "Avis court affiché en grand sur l'écran de l'appareil en moins d'une minute.", "device_msg_ph": "Ex. : Fermeture dans 10 minutes", "device_msg_q1": "Fermeture dans 10 minutes", "device_msg_q2": "Veuillez faire la clôture de caisse", "device_msg_q3": "Appelez l'administrateur", "remote_msg_from": "Message de l'administrateur",
  "device_cmd_sent": "Commande envoyée : l'appareil l'exécutera en moins d'une minute", "device_cmd_pending": "En attente", "device_cmd_reload": "Recharger", "device_cmd_update": "Mettre à jour",
  "received": "Reçu",
  "icon_search_ph": "Rechercher une icône : pain, fromage, thé…", "icon_search_empty": "Aucune icône ne correspond.",
  "waste_title": "Pertes et casse", "waste_desc": "Produits périmés, abîmés ou impropres à la consommation. Déduits du stock et comptés comme perte.", "waste_losses": "Pertes stock", "waste_expired": "Périmé", "waste_damaged": "Abîmé / cassé", "waste_unfit": "Impropre à la consommation", "waste_other": "Autre", "waste_add": "Enregistrer la perte", "waste_saved": "Perte enregistrée", "waste_search_ph": "Rechercher un produit…", "waste_pick": "Choisir un produit", "waste_qty": "Quantité", "waste_unit_cost": "Coût unitaire", "waste_loss": "Perte", "waste_total": "Perte totale", "waste_units": "Unités", "waste_empty": "Aucune perte enregistrée.", "waste_by_reason": "Par motif", "waste_top": "Produits les plus perdus", "waste_report": "Rapport PDF", "waste_this_month": "Ce mois", "waste_undo": "Annuler (remet le stock)", "waste_undone": "Perte annulée", "waste_manual": "Produit sans fiche", "waste_free_name": "Nom du produit", "pdf_waste": "Pertes et casse", "reason": "Motif", "loss": "Perte", "act_waste.create": "Perte enregistrée", "act_waste.delete": "Perte annulée",
  "perm_cameras": "Caméras de surveillance", "cam_title": "Caméras", "cam_desc": "Connectez les caméras du local (RTSP, HLS ou MJPEG) et surveillez en direct depuis l'app.", "cam_add": "Ajouter une caméra", "cam_edit": "Modifier la caméra", "cam_name": "Nom", "cam_url": "URL de la caméra", "cam_url_hint": "rtsp://utilisateur:motdepasse@IP:554/… (converti sur le serveur), ou une URL http(s) .m3u8 / MJPEG directe.", "cam_location": "Emplacement (caisse, réserve, entrée…)", "cam_saved": "Caméra enregistrée", "cam_deleted": "Caméra supprimée", "cam_delete_confirm": "Supprimer cette caméra ?", "cam_empty": "Aucune caméra pour l'instant. Ajoutez la première avec son URL RTSP.", "cam_grid": "Grille", "cam_live": "EN DIRECT", "cam_connecting": "Connexion…", "cam_error": "Pas de signal", "cam_retry": "Réessayer", "cam_fullscreen": "Plein écran", "cam_no_ffmpeg": "Le serveur n'a pas ffmpeg : les caméras RTSP ne peuvent pas être converties. Utilisez des URLs HLS/MJPEG.", "cam_rtsp_hint": "La caméra doit être accessible depuis Internet (IP publique ou redirection de port). Pour la plupart des DVR/NVR : rtsp://user:pass@IP:554/Streaming/Channels/101 (Hikvision) ou rtsp://user:pass@IP:554/cam/realmonitor?channel=1&subtype=1 (Dahua).", "cam_limit": "Maximum 16 caméras par local", "cam_move_up": "Monter", "cam_move_down": "Descendre", "cam_kind_rtsp": "RTSP (serveur)", "cam_kind_hls": "HLS", "cam_kind_mjpeg": "MJPEG / image", "cam_kind_phone": "Téléphone comme caméra", "cam_stream_failed": "Impossible d'ouvrir le flux. Vérifiez l'URL, l'identifiant/mot de passe et l'accessibilité depuis Internet.",
  "cam_type_rtsp": "Caméra IP / Wi-Fi", "cam_type_phone": "Téléphone comme caméra", "cam_type_hls": "Lien HLS", "cam_type_mjpeg": "Lien MJPEG", "cam_type_rtsp_hint": "Caméras IP ou Wi-Fi (Hikvision, Dahua, Tapo, Reolink, Xiaomi…) et DVR/NVR. Choisissez la marque, saisissez IP, identifiant et mot de passe : l'URL se construit seule. Le serveur la convertit pour tout navigateur.", "cam_type_phone_hint": "Utilisez un vieux téléphone ou une tablette comme caméra Wi-Fi : un QR est généré, scannez-le, appuyez sur Démarrer et les images arrivent en direct. Aucune IP publique ni réglage routeur.", "cam_type_hls_hint": "Lien .m3u8 public (caméras cloud, NVR avec HLS, serveurs de streaming).", "cam_type_mjpeg_hint": "Lien http(s) vidéo MJPEG ou image rafraîchie (apps IP Webcam / DroidCam, webcams, ESP32-CAM).", "cam_brand": "Marque / modèle", "cam_builder": "Connexion Wi-Fi / réseau", "cam_ip": "IP ou DDNS", "cam_port": "Port", "cam_user": "Identifiant", "cam_pass": "Mot de passe", "cam_channel": "Canal", "cam_substream": "Sous-flux (léger)", "cam_use_builder": "Construire l'URL avec IP / identifiant", "cam_use_manual": "Saisir l'URL manuellement", "cam_quality": "Qualité du streaming", "cam_quality_copy": "Originale (sans réencodage)", "cam_quality_low": "Légère 480p", "cam_quality_medium": "Moyenne 720p", "cam_quality_hint": "Originale consomme moins de CPU. Utilisez Légère/Moyenne si la caméra émet en H.265 ou si la connexion est lente.", "cam_test": "Tester la connexion", "cam_testing": "Test…", "cam_test_fail": "Échec", "cam_needs_transcode": "pas en H.264 → choisissez Légère ou Moyenne", "cam_create_qr": "Créer et afficher le QR", "cam_phone_scan": "Scannez avec le téléphone qui servira de caméra", "cam_phone_how": "Ouvrez le lien dans Chrome/Safari du téléphone, autorisez la caméra et appuyez sur Démarrer. Laissez-le branché, écran allumé. Fonctionne en Wi-Fi ou données.", "cam_copy_link": "Copier le lien", "cam_new_link": "Nouveau lien (annule l'ancien)", "cam_phone_invalid": "Lien invalide ou expiré. Demandez un nouveau QR au propriétaire.", "cam_phone_denied": "Impossible d'accéder à la caméra du téléphone. Autorisez l'accès dans le navigateur.", "cam_phone_start": "Démarrer la caméra", "cam_phone_stop": "Arrêter", "cam_phone_tip": "Astuce : plus de fps et de résolution consomment plus de données. 2 fps · 960p est un bon équilibre.", "copied": "Copié",
  "cust_vehicles": "Véhicules du client", "add_vehicle": "Ajouter un véhicule", "plate": "Immatriculation", "year": "Année", "km": "Km", "plate_search_ph": "Immatriculation / VIN…", "sell_for_vehicle": "Vendre pour ce véhicule", "maint_due": "Entretien en retard : vidange", "maint_soon": "Vidange bientôt", "maint_ok": "Entretien à jour", "maint_unknown": "Pas d'historique de vidange", "maint_last_oil": "Dernière vidange", "warranty": "Garantie", "months_short": "mois", "warranty_months": "Garantie (mois)", "warranty_until": "garantie jusqu'au", "warranty_ok": "Sous garantie", "warranty_expired": "Hors garantie", "alt_refs": "Références équivalentes (Bosch, Febi, Valeo…)", "part_orders": "Commandes de pièces", "part_orders_desc": "Commandez des pièces hors stock avec acompte, fournisseur et date prévue ; prévenez le client par WhatsApp à l'arrivée.", "po_new": "Nouvelle commande de pièce", "po_part": "Pièce", "po_part_ph": "Alternateur Hilux 2.4, pompe à eau…", "po_expected": "Date d'arrivée prévue", "po_notify": "Prévenir le client (WhatsApp)", "po_notify_msg": "Votre pièce {part} {ref} est disponible en magasin. À bientôt !", "co_part_order": "Commande de pièce", "cat_part_order": "Commande de pièce",
  "cat_fabrics": "Tissus et matériaux", "fabric_m": "Mètres de tissu", "is_module": "Module du configurateur", "is_module_hint": "Apparaît dans le configurateur salon/canapé pour composer des ensembles", "fabric_hint": "Prix au mètre · stock en mètres. Déduit à la confirmation des commandes et ensembles.", "fabric_short": "tissu", "seats_short": "pl.", "cfg_btn": "Configurer", "cfg_title": "Configurateur salon / canapé", "cfg_no_modules": "Aucun module dans cette catégorie. Cochez « Module du configurateur » sur les produits.", "cfg_fabric": "Tissu", "cfg_no_fabric": "Sans tissu / inclus", "cfg_modules": "Modules", "cfg_add_cart": "Ajouter l'ensemble au panier", "fabric_deducted": "tissu déduit", "quote_save_as": "Enregistrer comme devis", "quote_hint": "Sans acompte ni stock ; converti en commande en un clic", "quote_valid_until": "Valable jusqu'au", "quote_options": "Options", "quote_option_ph": "Option B : tissu premium…", "quote_add_option": "Ajouter une option", "quote_save": "Enregistrer le devis", "quote_pdf": "Devis", "quote_convert": "Convertir en commande", "quote_converted": "Devis converti en commande", "co_quote": "Devis", "prod_title": "Production", "prod_hint": "Ajoutez une photo d'avancement à chaque étape pour la montrer au client.", "stage_carpentry": "Menuiserie", "stage_upholstery": "Tapisserie", "stage_sewing": "Couture", "stage_finishing": "Finition", "stage_quality": "Contrôle et prêt", "proof_title": "Livraison avec signature", "proof_received_by": "Reçu par", "proof_signature": "Signature du client", "proof_photo": "Photo au domicile", "proof_skip": "Livrer sans signature", "proof_signed": "Signé", "planner_title": "Planificateur de pièce", "planner_room_w": "Largeur", "planner_room_l": "Longueur", "planner_hint": "Glissez les meubles sur le plan ; sélectionnez-en un pour le tourner de 90° ou le retirer. Échelle réelle selon les dimensions du produit.", "planner_no_products": "Ajoutez des dimensions (largeur × profondeur) aux produits pour les utiliser ici.",
  "cash_statement": "Arrêté de caisse", "details": "Détails", "hr_breakdown": "Détail de la paie", "hr_incentives": "Primes", "hr_other_earnings": "Autres gains", "hr_debt_deduct": "Retenue dettes", "hr_total_to_pay": "Total à payer", "hr_shortfall": "Retenues supérieures au salaire (reste en attente)", "hr_status_paid": "Payée", "hr_status_pending": "En attente de paiement", "hr_payroll_saved": "Paie enregistrée", "payslip_code": "Code de bulletin", "hr_kind_payroll": "Paie", "shift_open": "Service ouvert (partiel)", "issue_date": "Date d'émission", "employment_details": "Données de l'emploi", "hr_rate": "Base (montant)", "days_worked": "Jours travaillés", "hours_worked": "Heures", "earnings": "Gains", "hr_incentive": "Prime", "total_earnings": "Total brut", "total_deductions": "Total retenues", "months_short": "mois", "payslip_legal": "Bulletin de paie émis par l'employeur. Le salarié déclare avoir reçu le montant net indiqué. Conservez ce document.", "tax_rate": "Taux de taxe", "invoice_due_days": "Échéance facture (jours)", "tax_base": "Base imposable", "tax": "Taxe", "tax_amount": "Montant taxe", "tax_short": "TVA", "fin_invoice_items": "Libellés", "fin_no_payments": "Aucun paiement enregistré", "fin_invoice_total": "Total facture", "paid": "Payé", "pending": "Restant", "due_date": "Date d'échéance", "of": "de", "type": "Type", "description": "Description", "pay_type": "Mode d'encaissement", "cash_total": "Total caisse", "summary_by_concept": "Résumé par libellé", "summary_by_pay_type": "Résumé par mode d'encaissement", "cash_summary": "Résumé espèces", "cash_total_period": "Total espèces", "inflows": "Entrées", "outflows": "Sorties", "filters_applied": "Filtres appliqués au rapport", "cash_register": "Caisse", "cash_moves": "Mouvements de caisse", "sale": "Vente", "refund": "Remboursement", "consultations": "Consultations",
  "vsc_verify_title": "Vérifier l'ordonnance par VSC", "vsc_verify": "Vérifier", "vsc_valid": "Ordonnance authentique et non modifiée", "vsc_altered": "Attention ! L'ordonnance a été modifiée après émission ou le code ne correspond pas", "vsc_not_found": "Code VSC introuvable : ordonnance non émise par une clinique Orbit",
  "vsc_title": "Validation VSC", "vsc_issued": "Émise le", "vsc_hint": "Code de vérification unique généré à l'instant de l'émission. La pharmacie peut le vérifier avec le code ℞ dans Orbit.", "design_stamp": "Concevoir le cachet", "draw_signature": "Dessiner la signature", "shape_circle": "Rond", "shape_oval": "Ovale", "shape_rect": "Rectangulaire", "stamp_top": "Texte supérieur (clinique)", "stamp_line2": "Ligne 2 (n° d'ordre…)", "stamp_line3": "Ligne 3 (téléphone…)", "stamp_bottom": "Texte inférieur (spécialité)", "stamp_transparent_hint": "Fond transparent : se superpose proprement sur ordonnances et rapports.", "use_this_stamp": "Utiliser ce cachet", "use_this_signature": "Utiliser cette signature", "signature_pad_hint": "Signez au doigt, stylet ou souris. Enregistrée en PNG transparent.", "clear": "Effacer", "reg_no": "N°",
  "ws_title": "Fournisseurs Orbit", "stamp_image": "Cachet (image)", "stamp_hint": "Signature et cachet sont ajoutés automatiquement aux ordonnances, rapports et dossiers patients.", "auto": "Automatique", "block_yearly": "Chaque année (férié)", "block_yearly_hint": "Se répète chaque année à cette date et bloque toute la clinique (Aïd, fêtes nationales…).", "block_every": "Chaque année ·", "slot_blocked": "Ce créneau est bloqué", "block_title": "Bloquer des créneaux", "block_all_doctors": "Toute la clinique", "block_whole_day": "Journée entière", "block_some_hours": "Quelques heures", "block_add": "Bloquer", "block_added": "Créneau bloqué", "block_existing": "Blocages à venir", "reason": "Motif", "ws_register_serves": "Quels secteurs allez-vous fournir ?", "ws_register_serves_hint": "L'équipe Orbit examinera votre demande ; d'ici là vous n'apparaissez pas dans l'annuaire des fournisseurs.", "ws_pending_admin": "En attente de validation par Orbit", "poster_title": "Affiche A4 salle d'attente", "poster_headline": "Prenez rendez-vous depuis votre mobile", "poster_sub": "Scannez le code et choisissez jour et heure sans attendre.", "poster_step1": "Ouvrez l'appareil photo et scannez le QR", "poster_step2": "Choisissez médecin, jour et heure", "poster_step3": "Recevez la confirmation immédiatement", "landing_pick_type": "Choisissez votre type d'activité", "saas_secure_short": "Sauvegarde sûre dans le cloud", "booking_qr_hint": "Imprimez ce QR pour l'accueil ou partagez le lien : les patients prennent rendez-vous depuis leur mobile.", "booking_qr_print_sub": "Scannez pour prendre rendez-vous", "print_qr": "Imprimer le QR", "copy_link": "Copier le lien", "booking_share_text": "Prenez rendez-vous chez {shop} ici :", "ws_pay_cash_debt": "Espèces + dette", "ws_pays_cash": "Paie en espèces", "ws_display_orders": "Afficher les commandes sur l'écran client", "ws_display_orders_hint": "L'écran client (F10 / écran distant) affiche un tableau des commandes reçues et leur état pour que les boutiques sachent quand venir.", "ws_board_title": "Commandes en cours", "ws_board_sub": "Envoyée → Vue → En préparation → Prête", "ws_board_empty": "Aucune commande en attente", "sc_f4": "Fermer toutes les fenêtres ouvertes (et l'écran client) · au TPV sans fenêtre : encaisser espèces", "display_closed_hint": "Écran fermé (F4). Touchez pour réafficher.", "ws_available": "Disponible", "ws_reserved": "réservé", "ws_insufficient": "Stock insuffisant", "display_password": "Mot de passe de l'écran", "display_password_ph": "4 caractères minimum", "display_password_saved": "Mot de passe enregistré. Les écrans connectés devront le ressaisir.", "display_pw_set": "protégé", "display_pw_unset": "sans mot de passe", "display_pw_change": "Changer", "display_install_hint": "Sur l'autre écran (tablette, TV, PC) ouvrez {url}, installez-le comme app et connectez-vous avec le code et ce mot de passe.", "display_pair_title": "Écran client Orbit", "display_pair_hint": "Connectez cet écran à votre boutique, pharmacie, clinique…", "display_pair_reauth": "Le mot de passe a changé ou la session a expiré. Reconnectez-vous.", "display_connect": "Connecter", "display_bad_password": "Mot de passe incorrect", "display_bad_code": "Code introuvable", "acct_pending_title": "Compte en attente d'approbation", "acct_pending_desc": "Nous avons reçu la demande de « {shop} ». L'équipe Orbit va l'examiner et activer votre compte sous peu. Cet écran se met à jour tout seul.", "acct_rejected_title": "Demande refusée", "acct_rejected_desc": "La demande de « {shop} » n'a pas été approuvée. Contactez l'équipe Orbit.", "acct_check_again": "Vérifier à nouveau", "acct_requests": "Demandes de compte", "acct_pending": "En attente", "acct_rejected": "Refusée", "acct_approved": "Approuvée", "acct_reason_ph": "Motif (optionnel)", "acct_approved_ok": "Compte approuvé", "acct_rejected_ok": "Compte refusé", "inv_title": "Factures d'abonnement", "inv_invoice": "Facture", "inv_alert_title": "Vous avez {n} facture(s) d'abonnement en attente", "inv_view": "Voir la facture", "inv_new_hint": "Orbit vous a envoyé cette facture d'abonnement. Vérifiez-la et, une fois payée, marquez-la comme payée dans Facturation.", "inv_go_pay": "Aller payer", "inv_issue": "Émettre une facture", "inv_send": "Envoyer la facture", "inv_due": "Échéance", "inv_issued": "Émise", "inv_claimed": "Paiement déclaré", "inv_paid": "Payée", "inv_cancelled": "Annulée", "inv_mark_paid": "Confirmer l'encaissement", "inv_cancel_confirm": "Annuler cette facture ?", "inv_issued_ok": "Facture envoyée au commerce", "inv_paid_ok": "Encaissement confirmé, plan activé", "inv_cancelled_ok": "Facture annulée", "inv_none": "Aucune facture", "inv_admin_hint": "Confirmer l'encaissement active/renouvelle automatiquement le plan du commerce.", "inv_claimed_count": "Paiements à confirmer", "inv_billed_to": "Facturé à", "inv_subscription": "Abonnement Orbit PMS", "inv_i_paid": "J'ai payé", "inv_claim_ok": "Paiement déclaré. Orbit le confirmera sous peu.", "inv_claim_hint": "Indiquez le mode de paiement et la référence. L'équipe Orbit confirmera et activera votre plan.", "inv_claimed_on": "Paiement déclaré le", "inv_m_cash": "Espèces", "inv_m_transfer": "Virement", "inv_m_ccp": "CCP", "inv_m_baridimob": "BaridiMob", "inv_m_other": "Autre", "ws_statement": "Relevé de compte", "concept": "Libellé", "ws_st_debit": "Débit", "ws_st_credit": "Crédit", "ws_st_opening": "Solde initial", "ws_st_closing": "Solde dû à la clôture", "ws_st_current": "Solde actuel", "ws_st_order": "Commande", "ws_st_payment": "Paiement", "ws_st_refund": "Remboursement", "ws_st_mirror": "enregistré par l'autre partie", "ws_st_orders_total": "Total commandes de la période", "ws_st_empty": "Aucun mouvement sur la période", "ws_debt_we_owe": "Nous devons aux grossistes Orbit", "ws_debt_owed_to_us": "Clients Orbit endettés", "ws_debt_collect": "Encaisser", "ws_debt_pay": "Payer", "ws_debt_remaining": "Reste en dette", "ws_debt_hint_sup": "Chaque boutique qui commande devient votre client (dans Clients). Encaisser la dette là-bas la déduit chez la boutique.", "ws_debt_hint_buyer": "Le reste est enregistré dans Achats › Fournisseurs. En payant là-bas, le grossiste le voit déduit.", "subtotal": "Sous-total", "search_product": "Rechercher un produit…", "ws_order_sheet": "Commande grossiste", "ws_supplier": "Fournisseur", "ws_buyer": "Client", "ws_edit_order": "Modifier la commande", "ws_add_product": "Ajouter un produit du catalogue…", "ws_disc_reason": "Motif (client fidèle, volume…)", "ws_disc_remove": "Retirer la remise", "pos_disc_btn": "Remise", "pos_disc_title": "Remise sur le ticket", "pos_disc_hint": "Appliquée sur le total du ticket (en plus des promotions et remises par ligne).", "ws_desc": "Grossistes du réseau Orbit qui servent votre secteur : consultez catalogue et prix, envoyez la commande et retirez-la quand elle est prête. L'achat entre seul dans votre stock.", "ws_hub_title": "Commandes clients (grossiste)", "ws_hub_desc": "Choisissez les secteurs que vous servez et recevez les commandes des boutiques, pharmacies, cliniques… Préparez-les, marquez-les prêtes et encaissez au retrait.", "ws_suppliers": "Fournisseurs", "ws_my_orders": "Mes commandes", "ws_compare": "Comparer les prix", "ws_compare_ph": "Tapez un produit pour comparer entre fournisseurs…", "ws_best_price": "Meilleur prix", "ws_no_suppliers": "Aucun grossiste ne sert encore votre secteur.", "ws_no_orders": "Aucune commande.", "ws_no_products": "Aucun produit.", "ws_no_ratings": "Aucun avis", "ws_ratings": "avis", "ws_rate": "Noter", "ws_rate_after": "Vous pouvez noter après avoir retiré une commande", "ws_order_now": "Voir le catalogue et commander", "ws_order": "Commande", "ws_pickup_date": "Date de retrait", "ws_send_order": "Envoyer la commande", "ws_sent_ok": "Commande envoyée au fournisseur", "ws_min_order": "Commande minimum", "ws_open_orders": "Commandes ouvertes", "ws_ready_count": "Prêtes à retirer", "ws_ready_banner": "Prête ! Passez la retirer à l'entrepôt du fournisseur.", "ws_sent": "Envoyée", "ws_seen": "Vue", "ws_preparing": "En préparation", "ws_ready": "Prête à retirer", "ws_collected": "Retirée", "ws_rejected": "Refusée", "ws_cancelled": "Annulée", "ws_mark_seen": "Marquer vue", "ws_mark_preparing": "Commencer la préparation", "ws_mark_ready": "Prête à retirer", "ws_mark_collected": "Retirée · encaisser", "ws_reject_reason": "Motif du refus (optionnel)", "ws_collected_ok": "Commande retirée et encaissée. L'achat est dans la boutique du client.", "ws_collect_hint": "La vente est enregistrée dans votre caisse et l'achat (avec stock) est créé chez le client. Crédit = reste dû au fournisseur.", "ws_new_orders": "Nouvelles", "ws_today_collected": "Encaissé aujourd'hui", "ws_profile": "Mon profil grossiste", "ws_visible": "Visible", "ws_serves": "Je sers", "ws_description": "Description (produits, conditions…)", "ws_pickup_hours": "Horaires de retrait",
  "debt_aging": "Ancienneté des dettes", "debt_aging_desc": "Toutes les dettes clients classées par ancienneté (FIFO : les paiements soldent d'abord les ventes les plus anciennes).", "aging_report": "Rapport PDF", "aging_empty": "Aucune dette en attente.", "age_b7": "0–7 jours", "age_b15": "8–15 jours", "age_b30": "16–30 jours", "age_b60": "1–2 mois", "age_b90": "2–3 mois", "age_b90p": "+3 mois", "age_oldest": "Plus ancienne", "age_days": "Jours", "age_range": "Ancienneté", "age_pending": "Restant", "age_opening": "Solde antérieur", "days": "jours", "last_payment": "Dernier paiement", "search_customer": "Rechercher un client…",
  "ra_shop": "Magasin cible", "ra_shop_any": "N'importe quel magasin (le propriétaire saisit son e-mail)", "ra_shop_hint": "L'application installée ouvrira directement l'accès de ce magasin avec l'e-mail du propriétaire pré-rempli.", "login_for_shop": "Accès pour", "devices_title": "Appareils installés", "devices_desc": "Chaque PC / écran avec la RemoteApp envoie un signal chaque minute. Vert = vu dans les 12 dernières minutes.", "devices_empty": "Aucun appareil pour l'instant. Installez la RemoteApp sur un PC et il apparaîtra ici.", "device": "Appareil", "version": "Version", "last_seen": "Dernière connexion", "display_screen": "Écran client", "refresh": "Actualiser",
  "ra_title": "RemoteApp · installation sur les PC / Mac des clients", "ra_desc": "Seul le Super Admin génère les installateurs. Choisissez les options, copiez la commande ou téléchargez le fichier et exécutez-le sur l'ordinateur du magasin.", "ra_cmd_hint": "Commande courte (tient dans Exécuter de Windows) et sans PowerShell. Le lien est valable 7 jours et n'est généré que depuis ce panneau.", "ra_regen": "Nouveau lien", "ra_token_hint": "Les liens expirent après 7 jours ; cliquez « Nouveau lien » pour en générer un autre.", "ra_feat_lock": "Application verrouillée : pas de clic droit, pas d'inspection, pas d'outils développeur (stratégie Edge/Chrome), pas d'onglets ni de barre d'adresse, pas d'extensions ni de gestes de navigation.", "ra_only_admin": "L'installation bureau (RemoteApp) est effectuée par le Super Admin depuis son panneau.", "tab_remoteapp": "RemoteApp",
  "oneline_title": "Installation recommandée : une commande (sans PowerShell, sans avertissement)", "oneline_desc": "Fonctionne même si PowerShell est bloqué sur le PC : n'utilise que cmd et curl de Windows. Installe directement depuis le serveur sans avertissement « Éditeur inconnu ».", "oneline_s1": "Appuyez sur Windows + R, collez la commande et validez.", "oneline_s2": "Patientez quelques secondes : « Orbit PMS » et « Orbit Écran client » apparaissent sur le Bureau et le menu Démarrer.", "oneline_s3": "Orbit PMS s'ouvre automatiquement à la fin.", "remoteapp_or_file": "Ou téléchargez le fichier (dans l'avertissement Windows cliquez « Exécuter ») :", "copied": "Copié", "copy_fail": "Copie impossible", "copy": "Copier",
  "kiosk_title": "Mode kiosque et démarrage automatique", "kiosk_on": "Mode kiosque", "kiosk_desc": "Garde l'application en plein écran sur ce poste ; pour quitter, fermer ou réduire, le PIN du propriétaire ou du responsable est demandé.", "kiosk_exit": "Quitter le kiosque", "kiosk_relock": "Verrouiller le kiosque", "kiosk_exit_title": "PIN du propriétaire", "kiosk_exit_desc": "Saisissez le PIN d'un propriétaire ou responsable pour quitter le mode kiosque.", "kiosk_unlocked": "Kiosque déverrouillé pour cette session", "autostart_title": "Démarrage automatique avec Windows / macOS", "autostart_desc": "Choisissez ce qui s'ouvre à l'allumage du PC et téléchargez l'installateur : il crée les raccourcis dans le dossier Démarrage.", "autostart_app": "Ouvrir Orbit PMS à l'allumage", "autostart_display": "Ouvrir l'écran client à l'allumage", "autostart_kiosk": "Mode kiosque (plein écran sans barre de titre : pas de boutons réduire / fermer)", "update_ready": "Une nouvelle version d'Orbit PMS est prête.", "update_reload": "Mettre à jour", "update_later": "Plus tard",
  "remoteapp_title": "Installateur RemoteApp depuis le serveur", "remoteapp_desc": "Téléchargez l'installateur et exécutez-le : il crée « Orbit PMS » et « Orbit Écran client » sur le Bureau et le menu Démarrer, avec icône et fenêtre propres. Sans barre d'adresse, sans onglets, sans menu du navigateur : clic droit et raccourcis navigateur désactivés.", "remoteapp_win": "Télécharger pour Windows", "remoteapp_mac": "Télécharger pour macOS", "remoteapp_hint": "Windows : si SmartScreen apparaît, cliquez « Informations complémentaires → Exécuter quand même ». macOS : clic droit → Ouvrir. Nécessite Microsoft Edge ou Google Chrome comme moteur.", "install_feat4": "Mode bureau : clic droit, F12, Ctrl+U et raccourcis navigateur désactivés.",
  "desktop_app": "Application de bureau (RemoteApp)", "install_how": "Comment installer ?", "install_display_window": "Ouvrir l'écran client dans sa propre fenêtre", "install_display_hint": "L'écran client (/display) peut aussi être installé comme application indépendante en plein écran sur le moniteur du client.", "install_feat1": "S'ouvre dans sa propre fenêtre avec une icône sur le bureau et le menu Démarrer, sans barres du navigateur.", "install_feat2": "Raccourcis : Vendre, Écran client, Rapports, Réglages (clic droit sur l'icône).", "install_feat3": "Fonctionne hors ligne et synchronise au retour d'internet ; mises à jour automatiques.", "install_ios1": "Ouvrez dans Safari et touchez le bouton Partager.", "install_ios2": "Choisissez « Sur l'écran d'accueil ».", "install_ios3": "Confirmez avec « Ajouter ».", "install_and1": "Dans Chrome touchez le menu ⋮.", "install_and2": "Touchez « Installer l'application » ou « Ajouter à l'écran d'accueil ».", "install_other1": "Utilisez Google Chrome ou Microsoft Edge pour installer comme application de bureau.",
  "charity_account": "Compte sadaqa", "charity_account_desc": "Toute la sadaqa encaissée s'accumule ici, séparée des ventes et des bénéfices, triée par ticket, date ou montant.", "charity_balance": "Solde cumulé", "charity_in_month": "Reçu ce mois", "charity_out_month": "Remis ce mois", "charity_payout": "Remettre la sadaqa", "charity_recipient": "Bénéficiaire", "charity_recipient_ph": "Mosquée, famille, association…", "charity_statement": "Relevé de sadaqa", "charity_empty": "Aucun mouvement de sadaqa ce mois", "charity_over_balance": "Dépasse le solde cumulé", "charity_in_drawer": "en caisse (hors ventes)", "total_paid": "Total payé", "sort_by": "Trier", "sort_date": "Date", "sort_ticket": "Ticket", "sort_amount": "Montant", "ticket": "Ticket", "act_charity.payout": "Remise de sadaqa",
  "display_charity_hint": "Souhaitez-vous ajouter cette sadaqa à votre achat ? Dites-le au vendeur.", "charity": "Sadaqa · صدقة", "charity_default_name": "Caisse de charité", "charity_amount": "Montant de la sadaqa", "charity_amount_hint": "0 = désactivé ; proposé au paiement", "charity_name": "Destination / nom de la charité", "charity_yes": "Oui, ajouter", "charity_no": "Non, merci", "charity_ask_hint": "Demandez au client s'il souhaite ajouter cette sadaqa à son achat. Elle peut être retirée du panier à tout moment.", "charity_verse_tr": "« Ceux qui dépensent leurs biens dans le sentier de Dieu ressemblent à un grain d'où naissent sept épis, à cent grains l'épi. Dieu multiplie pour qui Il veut. » (Coran 2:261)",
  "staff_photo": "Photo de l'employé", "add_photo": "Ajouter une photo", "change_photo": "Changer la photo",
  "viz_scene": "Scène fixe sur l'écran client", "viz_scene_hint": "enregistrez cette composition pour l'afficher sur l'écran client au repos", "viz_scene_active": "à l'écran : {n} produits dans la pièce", "viz_scene_save": "Enregistrer sur l'écran", "viz_scene_load": "Charger", "viz_scene_clear": "Retirer", "viz_scene_saved": "Scène enregistrée sur l'écran client", "viz_scene_cleared": "Scène retirée",
  "visualizer": "Aperçu dans votre salon", "visualizer_desc": "Placez canapés, salons et tapis sur la photo du salon du client, ajustez taille et rotation, et affichez-le sur l'écran client avec le prix.", "viz_send": "Afficher sur l'écran client", "viz_clear": "Retirer de l'écran", "viz_sent": "Envoyé à l'écran client", "viz_cleared": "Écran client libéré", "viz_room": "Pièce", "viz_room_default": "Salon vide", "viz_room_photo": "Photo de la pièce", "viz_size": "Taille", "viz_rotate": "Rotation", "viz_flip": "Retourner", "viz_blend": "Fond blanc transparent", "viz_empty": "Touchez un produit pour le placer", "viz_no_photos": "Ajoutez des photos à vos produits pour les utiliser ici", "viz_display_caption": "Voilà le rendu dans votre salon",
  "custom_orders": "Commandes sur mesure", "custom_orders_desc": "Salons arabes, canapés et tapis sur mesure : mesures, croquis, acompte et date de livraison. Calendrier des livraisons et montage.", "co_new": "Nouvelle commande sur mesure", "co_new_delivery": "Planifier une livraison", "co_title": "Description de la commande", "co_title_ph": "Salon arabe 8 places en L, tissu rouge…", "co_customer_required": "Choisissez un client ou indiquez un téléphone", "co_measurements": "Mesures et design", "co_sketch": "Croquis / photo", "co_notes_ph": "Détails du design, coussins, finitions…", "co_price": "Prix total", "co_deposit": "Acompte", "co_balance": "Reste à payer", "co_delivery_date": "Date de livraison", "co_assembly": "Notes de montage", "co_assembly_ph": "3e étage sans ascenseur · monter au salon · apporter une perceuse", "co_pending": "En attente", "co_in_progress": "En fabrication", "co_ready": "Prêt", "co_delivered": "Livré", "co_cancelled": "Annulé", "co_calendar": "Calendrier des livraisons", "co_late": "Livraisons en retard", "co_deliveries_week": "Livraisons sous 7 jours", "co_delivery_required": "Choisissez un ticket et une date", "price_per_m2": "Prix au m²", "price_per_m2_hint": "à la vente, largeur × longueur sont demandées et le prix calculé", "act_custom_order.upsert": "Commande sur mesure",
  "type_furniture": "Meubles et décoration", "cat_sofas": "Canapés", "cat_arabic_salon": "Salon arabe", "cat_hall": "Salle et salle à manger", "cat_bedroom": "Chambre", "cat_chairs": "Chaises et fauteuils", "cat_carpets": "Tapis", "cat_curtains": "Rideaux", "cat_mattresses": "Matelas", "cat_lighting": "Éclairage", "cat_decor": "Décoration", "cat_custom_design": "Design sur mesure", "material": "Matériau", "material_ph": "Bois, tissu, MDF, laine…", "color": "Couleur", "seats": "Places", "carpet_width": "Largeur", "carpet_length": "Longueur", "dim_width": "Largeur", "dim_depth": "Profondeur", "dim_height": "Hauteur", "made_to_order": "Fabrication sur mesure / sur commande", "made_to_order_hint": "fabriqué après la commande du client", "lead_days": "jours de délai", "spec": "Caractéristiques",
  "type_autoparts": "Pièces auto", "type_phones": "Téléphones et recharges", "type_hardware": "Quincaillerie",
  "cat_power_tools": "Outillage électrique", "cat_fasteners": "Visserie", "cat_plumbing": "Plomberie", "cat_paint": "Peinture", "cat_construction": "Construction", "cat_security": "Serrurerie", "cat_adhesives": "Colles et mastics", "cat_garden": "Jardin et arrosage", "cat_safety": "Protection",
  "cat_engine": "Moteur", "cat_brakes": "Freins", "cat_filters": "Filtres", "cat_suspension": "Suspension", "cat_electrical": "Électricité", "cat_oils": "Huiles et liquides", "cat_tires": "Pneus", "cat_body": "Carrosserie", "cat_accessories": "Accessoires", "cat_tools": "Outils",
  "cat_phones": "Téléphones", "cat_sim": "Cartes SIM", "cat_topup": "Recharges", "cat_repair": "Réparation",
  "brand": "Marque", "oem_ref": "Référence OEM", "vehicle_make": "Marque du véhicule", "vehicle_model": "Modèle", "vehicle_years": "Années", "vehicle": "Véhicule", "all_makes": "Toutes les marques", "all_models": "Tous les modèles", "parts_found": "{n} pièces",
  "topup": "Recharge", "topup_title": "Recharge de crédit", "topup_hint": "Mobilis (06), Djezzy (07) et Ooredoo (05). L'opérateur est détecté d'après le numéro. Effectuez la recharge depuis votre ligne distributeur et encaissez ici.", "topup_phone": "Numéro du client", "topup_custom": "Autre montant", "topup_pick_operator": "Choisissez l'opérateur", "topup_bad_phone": "Numéro algérien invalide (10 chiffres commençant par 05, 06 ou 07)", "topups_by_operator": "Recharges par opérateur",
  "pt_reports": "Rapports",
  "documents": "Documents",
  "full_history_report": "Rapport de dossier médical complet",
  "reports_by_visit": "Rapports par visite",
  "visit_report": "Rapport de consultation",
  "reports_by_diagnosis": "Rapports par maladie / diagnostic",
  "diagnosis_report": "Rapport par diagnostic",
  "signature_image": "Signature (image)",
  "erx_footer": "Ordonnance électronique Orbit : valable dans toute pharmacie ayant un compte Orbit grâce au code ℞.",
  "erx_title": "Ordonnance électronique",
  "erx_hint": "Recherchez par code ℞, téléphone, nom ou n° de dossier du patient. Les ordonnances émises par les cliniques Orbit apparaissent ici.",
  "erx_search_ph": "Code ℞ / téléphone / nom",
  "erx_empty": "Aucun résultat",
  "erx_issued": "En attente",
  "erx_dispensed": "Délivrée",
  "erx_no_stock": "Aucun équivalent en stock",
  "erx_dispense": "Délivrer dans cette vente",
  "search": "Rechercher",
  "specialty_exam": "Examen par spécialité",
  "no_template": "Aucun modèle spécifique",
  "growth_hint": "Ligne verte : médiane approx. OMS (±20 %). Bleu : poids du patient. Rouge : aujourd'hui.",
  "yes": "Oui",
  "no": "Non",
  "tooth_ok": "Sain",
  "tooth_caries": "Carie",
  "tooth_filled": "Obturée",
  "tooth_missing": "Absente",
  "tooth_crown": "Couronne",
  "tooth_root": "Dévitalisation",
  "tooth_implant": "Implant",
  "tp_head_circ": "Périmètre crânien cm",
  "tp_feeding": "Alimentation",
  "tp_development": "Développement psychomoteur",
  "tp_vaccines_ok": "Vaccins à jour",
  "tp_va_od_far": "AV OD loin",
  "tp_va_os_far": "AV OG loin",
  "tp_va_od_near": "AV OD près",
  "tp_va_os_near": "AV OG près",
  "tp_iop_od": "PIO OD",
  "tp_iop_os": "PIO OG",
  "tp_sph_od": "Sphère OD",
  "tp_cyl_od": "Cylindre OD",
  "tp_axis_od": "Axe OD",
  "tp_sph_os": "Sphère OG",
  "tp_cyl_os": "Cylindre OG",
  "tp_axis_os": "Axe OG",
  "tp_fundus": "Fond d'œil",
  "tp_ecg_rhythm": "Rythme ECG",
  "tp_ecg_hr": "FC ECG",
  "tp_murmur": "Souffles",
  "tp_echo_ef": "FEVG %",
  "tp_nyha": "Classe NYHA",
  "tp_risk_factors": "Facteurs de risque",
  "tp_lesion_site": "Localisation",
  "tp_lesion_type": "Type de lésion",
  "tp_lesion_size": "Taille",
  "tp_lesion_color": "Couleur",
  "tp_itch": "Prurit",
  "tp_derm_notes": "Description",
  "tp_joint": "Articulation",
  "tp_side": "Côté",
  "tp_rom": "Amplitude de mouvement",
  "tp_pain_scale": "Douleur (0-10)",
  "tp_trauma": "Traumatisme",
  "tp_imaging_result": "Rx / imagerie",
  "tp_mood": "Humeur",
  "tp_sleep": "Sommeil",
  "tp_appetite": "Appétit",
  "tp_phq9": "PHQ-9",
  "tp_gad7": "GAD-7",
  "tp_risk": "Risque",
  "tp_mental_notes": "Examen psychopathologique",
  "tp_therapy_plan": "Plan thérapeutique",
  "tp_ear_r": "Oreille droite",
  "tp_ear_l": "Oreille gauche",
  "tp_nose": "Nez",
  "tp_throat": "Gorge",
  "tp_hearing": "Audition",
  "tp_spo2_rest": "SpO₂ au repos",
  "tp_resp_rate": "Fréq. respiratoire",
  "tp_peak_flow": "Débit de pointe",
  "tp_auscultation": "Auscultation",
  "tp_abdomen": "Abdomen",
  "tp_bowel": "Transit",
  "tp_stool": "Selles",
  "tp_liver_spleen": "Foie / rate",
  "tp_hba1c": "HbA1c",
  "tp_glucose": "Glycémie",
  "tp_thyroid_exam": "Thyroïde",
  "tp_insulin": "Insuline",
  "tp_diet": "Régime actuel",
  "tp_target_weight": "Poids cible",
  "tp_waist": "Tour de taille cm",
  "tp_plan": "Plan",
  "tp_lmp": "DDR",
  "tp_pelvic_exam": "Examen pelvien",
  "tp_cervix": "Col utérin",
  "tp_discharge": "Pertes",
  "tp_breast": "Seins",
  "tp_contraception_advice": "Conseil contraceptif",
  "tp_fundal": "Hauteur utérine",
  "tp_fhr": "RCF",
  "tp_presentation": "Présentation",
  "tp_edema": "Œdèmes",
  "tp_urine_protein": "Protéinurie",
  "tp_urine_symptoms": "Symptômes urinaires",
  "tp_prostate": "Prostate",
  "tp_psa": "PSA",
  "tp_flow": "Débit",
  "tp_gcs": "Glasgow",
  "tp_reflexes": "Réflexes",
  "tp_motor": "Motricité",
  "tp_sensory": "Sensibilité",
  "tp_gait": "Marche",
  "tp_triage": "Triage",
  "tp_mechanism": "Mécanisme",
  "tp_interventions": "Interventions",
  "opt_left": "Gauche",
  "opt_right": "Droit",
  "opt_both": "Les deux",
  "opt_no": "Non",
  "opt_mild": "Léger",
  "opt_moderate": "Modéré",
  "opt_severe": "Sévère",
  "opt_normal": "Normal",
  "opt_insomnia": "Insomnie",
  "opt_hypersomnia": "Hypersomnie",
  "opt_low": "Bas",
  "opt_high": "Élevé",
  "opt_none": "Aucun",
  "opt_cephalic": "Céphalique",
  "opt_breech": "Siège",
  "opt_transverse": "Transverse",
  "opt_red": "Rouge",
  "opt_orange": "Orange",
  "opt_yellow": "Jaune",
  "opt_green": "Vert",
  "opt_blue": "Bleu",
  "pregnancy_alerts": "Alertes de grossesse",
  "delivery_due": "Accouchement ce mois-ci",
  "delivery_overdue": "Terme dépassé",
  "prenatal_due": "Consultation prénatale en attente",
  "labour_delivery": "Travail et accouchement",
  "continue_labour": "Poursuivre le partogramme",
  "partograph": "Partogramme",
  "labour_start": "Début du travail",
  "partograph_entries": "enregistrements",
  "labour_in_progress": "Travail en cours",
  "pg_time": "Heure",
  "pg_dilation": "Dilatation cm",
  "pg_fhr": "RCF",
  "pg_contractions": "Contr./10 min",
  "pg_bp": "TA",
  "pg_pulse": "Pouls",
  "pg_temp": "Temp",
  "pg_note": "Note",
  "delivery_outcome": "Données de l'accouchement",
  "delivery_mode": "Type d'accouchement",
  "mode_vaginal": "Voie basse",
  "mode_assisted": "Instrumental",
  "mode_cesarean": "Césarienne",
  "attended_by": "Pris en charge par",
  "newborn_sex": "Sexe du nouveau-né",
  "newborn_weight": "Poids (kg)",
  "newborn_length": "Taille (cm)",
  "baby_name": "Nom du bébé",
  "blood_loss": "Pertes sanguines (ml)",
  "complications": "Complications",
  "apgar_appearance": "Couleur",
  "apgar_pulse": "Pouls",
  "apgar_grimace": "Réflexes",
  "apgar_activity": "Tonus",
  "apgar_respiration": "Respiration",
  "birth_certificate": "Certificat de naissance",
  "birth_text": "Il est certifié que le {date} à {time}, {mother} a donné naissance à un nouveau-né de sexe {sex}, pesant {weight} kg, par accouchement {mode}.",
  "baby_of": "Bébé de",
  "mother": "Mère",
  "save_partograph": "Enregistrer le partogramme",
  "register_birth": "Enregistrer la naissance",
  "delivered": "Accouchement enregistré",
  "deliveries": "Accouchements",
  "delivery": "Accouchement",
  "specialty": "Spécialité",
  "pt_gyn": "Gynécologie",
  "gyn_history": "Antécédents gynéco-obstétricaux",
  "gyn_gravida": "Gestité (G)",
  "gyn_para": "Parité (P)",
  "gyn_abortions": "Fausses couches (A)",
  "gyn_living": "Enfants vivants",
  "gyn_menarche": "Ménarche (âge)",
  "gyn_cycle_days": "Cycle (jours)",
  "lmp": "DDR (dernières règles)",
  "edd": "DPA (date prévue d'accouchement)",
  "gestational_age": "Âge gestationnel",
  "weeks_short": "sem",
  "pregnant": "Enceinte",
  "menopause": "Ménopause",
  "contraception": "Contraception",
  "last_pap": "Dernier frottis",
  "last_mammo": "Dernière mammographie",
  "contra_none": "Aucune",
  "contra_pill": "Pilule",
  "contra_iud": "DIU",
  "contra_implant": "Implant",
  "contra_injection": "Injectable",
  "contra_condom": "Préservatif",
  "contra_natural": "Naturelle",
  "contra_sterilization": "Ligature",
  "prenatal_visit": "Consultation prénatale",
  "pn_weight": "Poids kg",
  "pn_bp": "TA",
  "pn_fundal": "Hauteur utérine cm",
  "pn_fhr": "RCF bpm",
  "pn_edema": "Œdèmes",
  "pn_urine_protein": "Protéinurie",
  "gyn_screening": "Dépistage et examens",
  "rec_prenatal": "Consultation prénatale",
  "rec_pap": "Frottis (Papanicolaou)",
  "rec_ultrasound": "Échographie",
  "rec_breast_exam": "Examen des seins",
  "sp_general": "Médecine générale",
  "sp_pediatrics": "Pédiatrie",
  "sp_gynecology": "Gynécologie",
  "sp_obstetrics": "Obstétrique",
  "sp_internal": "Médecine interne",
  "sp_cardiology": "Cardiologie",
  "sp_dermatology": "Dermatologie",
  "sp_ophthalmology": "Ophtalmologie",
  "sp_ent": "ORL",
  "sp_dentistry": "Odontologie",
  "sp_orthopedics": "Traumatologie",
  "sp_neurology": "Neurologie",
  "sp_psychiatry": "Psychiatrie",
  "sp_psychology": "Psychologie",
  "sp_nutrition": "Nutrition",
  "sp_physiotherapy": "Kinésithérapie",
  "sp_urology": "Urologie",
  "sp_endocrinology": "Endocrinologie",
  "sp_pulmonology": "Pneumologie",
  "sp_gastro": "Gastro-entérologie",
  "sp_nephrology": "Néphrologie",
  "sp_oncology": "Oncologie",
  "sp_surgery": "Chirurgie",
  "sp_emergency": "Urgences",
  "sp_radiology": "Radiologie",
  "sp_laboratory": "Laboratoire",
  "sp_nursing": "Soins infirmiers",
  "sp_midwifery": "Sage-femme",
  "sp_pharmacy_clinical": "Pharmacie clinique",
  "blood_analysis": "Analyse de sang",
  "lab_fill": "Saisissez au moins une valeur",
  "abnormal": "hors norme",
  "normal": "Normal",
  "test": "Examen",
  "unit": "Unité",
  "reference": "Référence",
  "flag": "Indicateur",
  "negative": "Négatif",
  "panel_cbc": "Hémogramme",
  "panel_glucose": "Glycémie",
  "panel_lipids": "Bilan lipidique",
  "panel_renal": "Fonction rénale / ionogramme",
  "panel_liver": "Bilan hépatique",
  "panel_thyroid": "Thyroïde",
  "panel_iron": "Fer",
  "panel_urine": "Urines",
  "lab_hb": "Hémoglobine",
  "lab_wbc": "Leucocytes",
  "lab_plt": "Plaquettes",
  "lab_hct": "Hématocrite",
  "lab_mcv": "VGM",
  "lab_neut": "Neutrophiles",
  "lab_lymph": "Lymphocytes",
  "lab_glu_fast": "Glycémie à jeun",
  "lab_hba1c": "HbA1c",
  "lab_chol": "Cholestérol total",
  "lab_ldl": "LDL",
  "lab_hdl": "HDL",
  "lab_tg": "Triglycérides",
  "lab_urea": "Urée",
  "lab_creat": "Créatinine",
  "lab_uric": "Acide urique",
  "lab_na": "Sodium",
  "lab_k": "Potassium",
  "lab_alt": "ALAT (GPT)",
  "lab_ast": "ASAT (GOT)",
  "lab_bili": "Bilirubine totale",
  "lab_alp": "Phosphatase alcaline",
  "lab_tsh": "TSH",
  "lab_ft4": "T4 libre",
  "lab_ferritin": "Ferritine",
  "lab_iron": "Fer sérique",
  "lab_u_protein": "Protéines urinaires",
  "lab_u_glucose": "Glucose urinaire",
  "lab_u_leuko": "Leucocytes urinaires",
  "certificates": "Certificats",
  "cert_sick_leave": "Certificat d'arrêt de travail",
  "cert_fitness": "Certificat d'aptitude",
  "cert_referral": "Lettre d'orientation",
  "refer_to": "Orienter vers",
  "rec_certificate": "Certificat",
  "rec_referral": "Orientation",
  "cert_sick_text": "Je certifie que {name} a été pris(e) en charge dans ce centre et nécessite un repos de {days} jours à compter du {from}.",
  "cert_fit_text": "Je certifie que {name} a été examiné(e) et est apte à l'activité demandée.",
  "cert_ref_text": "Le patient {name} est orienté vers {to} pour évaluation et traitement.",
  "vaccine_schedule": "Calendrier vaccinal",
  "vaccine_need_birth": "Ajoutez la date de naissance pour calculer le calendrier",
  "months_short": "m",
  "mark_given": "Administré",
  "given": "Administré",
  "vac_bcg": "BCG",
  "vac_hepb0": "Hépatite B (naiss.)",
  "vac_penta1": "Pentavalent 1",
  "vac_polio1": "Polio 1",
  "vac_rota1": "Rotavirus 1",
  "vac_pcv1": "Pneumocoque 1",
  "vac_penta2": "Pentavalent 2",
  "vac_polio2": "Polio 2",
  "vac_rota2": "Rotavirus 2",
  "vac_pcv2": "Pneumocoque 2",
  "vac_penta3": "Pentavalent 3",
  "vac_polio3": "Polio 3",
  "vac_pcv3": "Pneumocoque 3",
  "vac_measles1": "Rougeole 1",
  "vac_measles2": "Rougeole 2",
  "vac_dtp_booster": "Rappel DTP",
  "rx_gate_title": "Médicaments sur ordonnance",
  "rx_gate_required": "Indiquez le médecin et le patient pour délivrer des médicaments sur ordonnance",
  "rx_number": "N° d'ordonnance",
  "rx_register": "Registre des délivrances sur ordonnance",
  "rx_register_empty": "Aucune délivrance sur ordonnance",
  "expiring_90": "Expirent dans 90 jours",
  "products": "Produits",
  "type_clinic": "Clinique / Centre de santé",
  "clinic": "Clinique",
  "clinic_desc": "Patients, rendez-vous, consultations et services",
  "rb_clinic": "Clinique",
  "grp_clinic": "Clinique",
  "px_nav_customers": "Patients",
  "px_search_customers": "Rechercher un patient…",
  "px_customer_optional": "Patient (facultatif, cumule des points)",
  "px_customer": "Patient",
  "px_add_customer": "Nouveau patient",
  "px_edit_customer": "Modifier le patient",
  "px_no_customers": "Aucun patient",
  "px_conflict_duplicate_customer": "Patient en double",
  "px_customers_desc": "Patients, comptes et paiements",
  "px_rb_customers": "Patients",
  "px_grp_customers": "Patients",
  "px_tm_customer_id": "Identité des patients",
  "prenatal_card": "Carnet prénatal",
  "labs_and_vaccines": "Analyses, échographies et vaccins",
  "delivery_plan": "Plan d'accouchement",
  "danger_signs": "Signes d'alerte",
  "danger_signs_text": "Saignement, maux de tête intenses, vision floue, fièvre, perte de liquide, absence de mouvements fœtaux → consulter immédiatement",
  "next_visit": "Prochaine visite",
  "gs_pregnant": "Enceintes",
  "gs_postpartum": "Post-partum",
  "gs_contraception": "Planification familiale",
  "gs_screening": "Dépistage",
  "gs_meds": "Médicaments",
  "high_risk": "Haut risque",
  "low_risk": "Faible risque",
  "deliveries_month": "Accouchements ce mois-ci",
  "screening_due": "Dépistage en attente",
  "pap_due": "Frottis en attente",
  "mammo_due": "Mammographie en attente",
  "last_dose": "Dernière dose",
  "contra_record_dose": "Enregistrer dose / contrôle",
  "pp_visit_week1": "Visite 1re semaine",
  "pp_visit_6w": "Contrôle 6 semaines",
  "risk_teen": "Adolescente",
  "risk_age35": "≥ 35 ans",
  "risk_grand_multipara": "Grande multipare",
  "risk_recurrent_loss": "Fausses couches à répétition",
  "risk_hypertension": "TA élevée",
  "risk_proteinuria": "Protéinurie",
  "risk_chronic": "Maladie chronique",
  "risk_prev_cesarean": "Césarienne antérieure",
  "risk_post_term": "Terme dépassé",
  "gyn_treatment": "Traitement gynécologique",
  "gyn_med_contraindicated": "Contre-indiqué chez cette patiente",
  "safety_safe": "Sûr",
  "safety_caution": "Prudence",
  "safety_avoid": "À éviter",
  "pregnancy": "Grossesse",
  "lactation": "Allaitement",
  "search_medicine": "Rechercher un médicament…",
  "prescribe": "Prescrire",
  "dose": "Dose",
  "rec_contraception": "Contraception",
  "rec_gyn_treatment": "Traitement gyn.",
  "gg_prenatal": "Prénatal",
  "gg_hypertension": "Hypertension",
  "gg_emergency": "Urgence obstétricale",
  "gg_obstetric": "Obstétrique",
  "gg_symptoms": "Symptômes",
  "gg_infection": "Infections",
  "gg_contraception": "Contraception",
  "gg_fertility": "Fertilité",
  "gg_menstrual": "Menstruation",
  "gg_menopause": "Ménopause",
  "gg_lactation": "Allaitement",
  "clinic_scope": "Périmètre de la clinique",
  "scope_full": "Clinique complète",
  "scope_specialty": "Une seule spécialité",
  "scope_hint": "Avec une seule spécialité, le compte n'accède qu'à cette section (patients, agenda, consultations de cette spécialité) et le reste est bloqué.",
  "scope_badge": "Uniquement {name}",
  "apply": "Appliquer",
  "nursing": "Soins infirmiers",
  "today": "Aujourd'hui",
  "triage": "Triage",
  "triage_queue": "Patients à évaluer",
  "triage_pending": "Sans triage",
  "save_triage": "Enregistrer le triage",
  "chief_complaint": "Motif de consultation",
  "allergies_verified": "Allergies vérifiées",
  "triage_red": "Rouge · immédiat",
  "triage_orange": "Orange · urgent",
  "triage_yellow": "Jaune · prioritaire",
  "triage_green": "Vert · normal",
  "vital_resp": "FR /min",
  "vital_pain": "Douleur 0-10",
  "procedures_log": "Injections et pansements",
  "proc_injection": "Injection",
  "proc_dressing": "Pansement / bandage",
  "proc_iv": "Voie / perfusion",
  "proc_nebulization": "Nébulisation",
  "proc_vaccine_admin": "Vaccin",
  "proc_other": "Autre acte",
  "drug_dose": "Médicament et dose",
  "wound_dressing_detail": "Plaie et type de pansement",
  "site_route": "Voie / zone",
  "lot_number": "Lot",
  "by_order_of": "Sur prescription de",
  "record_procedure": "Enregistrer l'acte",
  "detail_required": "Indiquez le détail",
  "rec_triage": "Triage",
  "rec_nursing": "Soins infirmiers",
  "custom_range": "Plage personnalisée",
  "lab_orders": "Demandes",
  "lab_results": "Résultats",
  "lab_catalog": "Catalogue d'examens",
  "lab_catalog_hint": "Valeurs de référence par défaut (avec variantes selon le sexe et l'âge pédiatrique). Vous pouvez ajuster les limites ou ajouter vos propres examens.",
  "lab_order": "Demande d'analyses",
  "order_lab": "Demander",
  "pending_orders": "Demandes en attente",
  "os_ordered": "Demandé",
  "os_collected": "Prélevé",
  "os_resulted": "Résultat disponible",
  "mark_collected": "Prélèvement effectué",
  "enter_results": "Saisir les résultats",
  "urgent": "Urgent",
  "sample_id": "N° échantillon",
  "panel": "Bilan",
  "panel_custom": "Examens personnalisés",
  "ref_low": "Min.",
  "ref_high": "Max.",
  "sex_age_ranges": "Plages sexe / âge",
  "critical": "critique",
  "critical_values": "Valeurs critiques",
  "legend": "Légende",
  "out_of_range": "hors norme",
  "add_test": "Ajouter un examen",
  "sync_health": "État de la synchronisation", "sync_state_healthy": "Tout est synchronisé", "sync_state_pending": "En attente d'envoi", "sync_state_stale": "En attente depuis longtemps", "sync_state_issues": "Avec erreurs", "sync_state_offline": "Hors ligne", "storage": "Stockage", "storage_ok": "Protégé", "storage_risk": "À risque", "sync_details": "Voir les opérations", "retry": "Réessayer", "discard_op_confirm": "Abandonner cette opération en attente ? Elle ne sera pas envoyée au serveur.", "full_resync": "Resynchronisation complète", "full_resync_confirm": "Toutes les données seront retéléchargées du serveur. Les opérations en attente sont conservées. Continuer ?", "sync_health_hint": "Les opérations sont enregistrées sur cet appareil et envoyées au retour de la connexion. Si quelque chose reste longtemps en attente, vérifiez ici.", "just_now": "à l'instant", "sync_stale_warn": "{n} opérations non synchronisées depuis plus de 30 min", "sync_queue_big": "File de synchronisation volumineuse ({n}). Connectez-vous pour envoyer.", "auto_backups": "Sauvegardes automatiques", "auto_backups_hint": "Chaque nuit une copie complète est enregistrée sur le serveur (14 derniers jours). Téléchargez-la à tout moment.", "backup_now": "Créer une copie maintenant", "backup_created": "Copie créée", "no_backups": "Aucune copie pour l'instant", "backup_auto": "Automatique", "backup_manual": "Manuelle",
  "display_qr_stays": "Le code reste affiché jusqu'à la vente suivante", "rating_ask": "Comment s'est passée votre visite ?", "rating_thanks": "Merci pour votre avis !", "rating_none": "Aucune évaluation", "rating_votes": "avis", "satisfaction": "Satisfaction client", "satisfaction_hint": "avis des tickets numériques", "by_shift": "Par service", "by_staff": "Par employé",
  "spotlight_out_of_stock": "épuisé · masqué", "display_scan_receipt": "Scannez pour garder votre ticket numérique", "receipt_not_found": "Ticket introuvable",
  "spotlight": "Produit vedette", "spotlight_hint": "photo et prix sur l'écran client au repos ; masqué si le stock tombe à 0 ; programmable par jour et heure", "spotlight_pick": "Choisir un produit…", "spotlight_no_photo": "sans photo", "spotlight_note_ph": "Phrase courte : Nouveauté ! · Offre de la semaine…", "spotlight_refresh": "Actualiser prix/photo", "spotlight_empty": "Aucun produit vedette", "spotlight_badge": "Vedette",
  "admin_vault": "Caisse d'administration", "cancel": "Annuler", "ticker_schedule": "Messages programmés", "ticker_schedule_hint": "par jour de la semaine et plage horaire ; si aucun ne s'applique, le message fixe s'affiche", "ticker_add_rule": "Ajouter un message", "ticker_live_now": "À l'écran maintenant", "ticker_from": "De", "ticker_to": "à", "ticker_time_hint": "vide = toute la journée", "ticker_no_rules": "Aucun message programmé", "display_ticker": "Message défilant", "display_ticker_hint": "ligne de bienvenue ou promotion qui défile en bas de l'écran client", "display_ticker_ph": "Bienvenue ! Aujourd'hui 2 pour 1 sur les jus · Merci de votre visite", "display_ticker_speed": "Vitesse", "display_theme": "Thème de l'écran client", "display_theme_hint": "Couleurs et fond assortis à votre marque", "theme_bg": "Fond", "theme_bg2": "Fond 2", "theme_accent": "Accent", "theme_accent2": "Accent 2", "theme_text": "Texte", "theme_stars": "Étoiles", "theme_bg_image": "Image de fond", "theme_dim": "Assombrir", "doc_footer": "Pied des factures et commandes", "doc_footer_hint": "coordonnées bancaires, mention légale…", "doc_footer_ph": "IBAN / RIB · Conditions de paiement · Nº d'enregistrement…", "bank_proof_title": "Justificatif de virement", "bank_proof_from": "Donneur d'ordre", "bank_proof_to": "Bénéficiaire", "bank_proof_created": "Ordonné le", "bank_proof_completed": "Terminé le", "bank_proof_ref": "Référence", "bank_proof_footer": "Virement entre banques virtuelles terminé avec un code à 12 chiffres vérifié par les deux parties", "bank_alert_incoming": "Virement reçu en attente", "bank_alert_completed": "Virement terminé", "bank_alert_cancelled": "Virement annulé", "bank_account_no": "Nº de compte virtuel", "bank_set_password": "Créer le mot de passe de la banque", "bank_change_password": "Changer le mot de passe", "bank_password": "Mot de passe de la banque", "bank_pw_hint": "Ce mot de passe protège les PIN cachés des virements entre banques virtuelles.", "bank_pw_current": "Mot de passe actuel", "bank_pw_new": "Nouveau mot de passe", "bank_pw_repeat": "Répéter le mot de passe", "bank_pw_short": "4 caractères minimum", "bank_pw_mismatch": "Les mots de passe ne correspondent pas", "bank_transfer_other": "Virer vers une autre banque virtuelle", "bank_transfer_send": "Envoyer", "bank_acc_not_found": "Compte introuvable", "bank_tf_created": "Virement créé · en attente", "bank_transfers": "Virements entre banques", "bank_hold": "En attente", "bank_completed": "Terminé", "bank_cancelled": "Annulé", "bank_tf_sent": "Envoyé", "bank_tf_received": "Reçu", "bank_tf_complete": "Terminer avec le code", "bank_tf_completed": "Virement terminé", "bank_tf_cancel_confirm": "Annuler le virement ? L'argent revient à l'émetteur.", "bank_pin_sender": "PIN émetteur", "bank_pin_receiver": "PIN récepteur", "bank_reveal_pin": "Voir le PIN", "bank_hold_hint": "Chaque partie voit son PIN à 6 chiffres (avec mot de passe). Les 12 chiffres ensemble terminent le virement.", "bank_code_hint": "Saisissez les 12 chiffres : PIN du récepteur + PIN de l'émetteur (ou l'inverse).", "bank_hint_transfer": "Le montant reste bloqué dans les deux banques jusqu'à la saisie du code à 12 chiffres.", "virtual_bank": "Banque virtuelle", "virtual_bank_desc": "Gardez l'argent non investi et les bénéfices : déposez, transférez depuis la caisse d'administration, retirez et suivez vos comptes d'épargne.", "bank_balance": "Solde de la banque", "bank_total_liquid": "Liquidité totale (caisse + banque)", "bank_accounts": "Comptes", "bank_account": "Compte", "bank_general": "Général", "bank_goal": "Objectif", "bank_add_account": "Ajouter un compte", "bank_deposit": "Déposer", "bank_withdraw": "Retirer", "bank_from_vault": "Transfert depuis la caisse admin.", "bank_to_vault": "Transfert vers la caisse admin.", "bank_insufficient": "Solde de la banque insuffisant", "bank_profit_note": "Ex. : bénéfice du mois", "bank_by_month": "Mouvement par mois", "void_move": "Annuler le mouvement", "bank_hint_in": "Enregistrez l'argent non investi dans l'entreprise (argent mis de côté).", "bank_hint_out": "Retrait virtuel : l'argent sort de la banque pour des dépenses personnelles ou un investissement.", "bank_hint_from_vault": "Déplacez le bénéfice de la caisse d'administration vers la banque : la caisse baisse, la banque monte.", "bank_hint_to_vault": "Ramenez de l'argent de la banque vers la caisse d'administration pour opérer.", "perm_bank": "Banque virtuelle", "act_bank.move": "Déposer / retirer / transférer", "act_bank.void": "Annuler des mouvements",
  "admin_vault_desc": "Coffre du propriétaire : transferts de la clôture de caisse",
  "vault_balance": "Solde du coffre",
  "vault_in": "Entrée",
  "vault_out": "Sortie",
  "vault_insufficient": "Solde insuffisant",
  "this_month": "Ce mois-ci",
  "transfer_ticket": "Ticket de transfert",
  "print_transfer": "Imprimer le transfert",
  "cash_register": "Caisse TPV",
  "external": "Externe",
  "shift_close_transfer": "Transfert de clôture de caisse", "confirm_close_title": "Confirmer la clôture de caisse", "float_kept": "Fonds de caisse conservé", "transfer_to_vault": "Transfert vers la caisse d'administration", "confirm_close_hint": "Seul l'argent des ventes du jour est transféré ; le fonds de caisse reste dans le tiroir pour le prochain service.", "vault_moves": "Mouvements", "cash_diff_alert": "Alerte d'écart de caisse", "cash_diff_alert_hint": "alerter si la clôture diffère de plus de (0 = désactivé)", "cash_diff_alert_msg": "Écart de caisse de {diff} (limite {limit}). Vérifiez la clôture.", "act_cash.diff_alert": "⚠ Écart de caisse", "shift_log": "Ouvertures et clôtures de caisse",
  "manual": "Manuel",
  "delivered_by": "Remis par",
  "received_by": "Reçu par",
  "by": "Par",
  "source": "Origine",
  "type": "Type",
  "sc_close": "Fermer la fenêtre",
  "book_appointment": "Prendre rendez-vous",
  "booking_confirmed": "Rendez-vous confirmé",
  "booking_keep_code": "Conservez ce code et présentez-le à l'accueil. Si vous n'aviez pas de dossier, un dossier a été créé avec le numéro indiqué.",
  "book_another": "Prendre un autre rendez-vous",
  "public_lead_hint": "Créneaux ouverts au public {h} h avant ; avant cela, réservés aux patients avec n° de dossier",
  "no_clinics_booking": "Aucune clinique n'accepte de rendez-vous en ligne pour le moment",
  "slot_open": "Ouvert à tous",
  "slot_patients_only": "Patients avec n° de dossier uniquement (jusqu'à {h} h avant)",
  "no_slots_day": "Pas de consultation ce jour",
  "confirm_booking": "Confirmer le rendez-vous",
  "file_no_not_found": "N° de dossier introuvable dans cette clinique",
  "slot_reserved_for_patients": "Ce créneau est réservé aux patients avec n° de dossier",
  "slot_taken": "Créneau déjà réservé",
  "online_booking": "Rendez-vous en ligne",
  "booking_enabled_label": "Autoriser les patients à prendre rendez-vous en ligne",
  "booking_lead_h": "Heures avant l'ouverture au public",
  "booking_days_ahead": "Nombre maximal de jours à l'avance",
  "booking_link": "Lien pour les patients",
  "appt_source_online": "En ligne",
  "manage_booking": "Gérer mon rendez-vous",
  "booking_code_label": "Code de confirmation",
  "find_booking": "Rechercher le rendez-vous",
  "booking_not_found": "Aucun rendez-vous trouvé avec ce code",
  "cancel_booking": "Annuler le rendez-vous",
  "booking_cancelled": "Rendez-vous annulé",
  "reschedule_booking": "Changer la date ou l'heure",
  "confirm_reschedule": "Confirmer le nouvel horaire",
  "booking_rescheduled": "Rendez-vous modifié",
  "booking_not_editable": "Ce rendez-vous ne peut plus être modifié",
  "booking_cancel_confirm": "Voulez-vous vraiment annuler ce rendez-vous ?",
  "pick_new_slot": "Choisissez un nouvel horaire pour votre rendez-vous",
  "booking_status": "Statut",
  "pt_devices": "Images et appareils",
  "rec_image": "Image/fichier",
  "rec_device": "Mesure d'appareil",
  "bt_vitals": "Constantes par Bluetooth",
  "bt_unsupported": "Bluetooth indisponible dans ce navigateur : utilisez Chrome ou Edge (Android/PC).",
  "bt_failed": "Impossible de connecter l'appareil",
  "bt_device": "Appareil Bluetooth",
  "save_reading": "Enregistrer la mesure",
  "btdev_bp": "Tensiomètre",
  "btdev_thermo": "Thermomètre",
  "btdev_spo2": "Oxymètre de pouls",
  "btdev_glucose": "Glucomètre",
  "btdev_scale": "Balance",
  "btdev_hr": "Cardiofréquencemètre",
  "device_capture": "Capture depuis caméra / échographe / dermatoscope",
  "device_capture_hint": "Branchez l'échographe ou tout appareil en USB/HDMI (carte d'acquisition) ou utilisez la caméra ; l'image est enregistrée dans le dossier du patient.",
  "video_source": "Source vidéo",
  "default_camera": "Caméra par défaut",
  "start_camera": "Démarrer",
  "stop": "Arrêter",
  "take_photo": "Prendre une photo",
  "record_clip": "Enregistrer un clip (15 s)",
  "stop_recording": "Arrêter l'enregistrement",
  "camera_failed": "Impossible d'accéder à la caméra ou à la carte d'acquisition",
  "device_import": "Scanner et importer des fichiers",
  "device_import_hint": "Scannez ou importez des photos, PDF, DICOM (.dcm), tracés ECG ou vidéos depuis n'importe quel appareil.",
  "choose_files": "Choisir des fichiers",
  "files_attached": "{n} fichier(s) joint(s)",
  "upload_failed": "Échec de l'envoi du fichier",
  "patient_images": "Images et documents du patient",
  "no_images_yet": "Aucune image ni fichier pour le moment.",
  "device_readings": "Mesures des appareils",
  "dicom_download_hint": "Fichier DICOM : téléchargez-le pour l'ouvrir avec votre visionneuse.",
  "download": "Télécharger",
  "delete": "Supprimer",
  "confirm_delete_file": "Supprimer ce fichier du dossier ?",
  "img_ultrasound": "Échographie",
  "img_dermatoscope": "Dermatoscopie",
  "img_wound": "Plaie / lésion",
  "img_ecg": "ECG",
  "img_xray": "Radiographie",
  "img_scan_doc": "Document scanné",
  "img_other": "Autre",
  "online_upcoming": "Prochains rendez-vous en ligne",
  "online_upcoming_empty": "Aucun rendez-vous en ligne pour le moment. Partagez le lien de Paramètres → Rendez-vous en ligne avec vos patients.",
  "owner_only_setting": "Seul le propriétaire ou le gérant peut le configurer",
  "agenda": "Agenda",
  "daily_cash": "Caisse du jour",
  "pt_billing": "Paiements",
  "patient_balance": "Solde dû",
  "pending_bills": "Consultations non réglées",
  "collect": "Encaisser",
  "pay_all": "Tout payer",
  "payment_received": "Paiement reçu",
  "payments": "Paiements",
  "invalid_amount": "Montant invalide",
  "debt_collected": "Dettes encaissées",
  "patients_owing": "Patients débiteurs",
  "appt_no_show": "Absent",
  "working_hours": "Horaires",
  "slot_minutes": "Minutes par rendez-vous",
  "from": "De",
  "to": "À",
  "day_mon": "Lun",
  "day_tue": "Mar",
  "day_wed": "Mer",
  "day_thu": "Jeu",
  "day_fri": "Ven",
  "day_sat": "Sam",
  "day_sun": "Dim",
  "patient_summary": "Fiche du patient",
  "none": "Aucune",
  "pf_sec_identity": "Identification",
  "pf_sec_contact": "Contact et résidence",
  "pf_sec_admin": "Administratif",
  "pf_sec_medical": "Données cliniques",
  "pf_sec_history": "Antécédents",
  "pf_father_name": "Nom du père",
  "pf_mother_name": "Nom de la mère",
  "pf_file_no": "N° de dossier",
  "pf_birth_place": "Lieu de naissance",
  "pf_nationality": "Nationalité",
  "pf_marital": "État civil",
  "pf_occupation": "Profession",
  "pf_education": "Niveau d'études",
  "pf_phone2": "Téléphone 2",
  "pf_email": "E-mail",
  "pf_wilaya": "Wilaya",
  "pf_daira": "Daïra / quartier",
  "pf_emergency_phone": "Tél. d'urgence",
  "pf_emergency_relation": "Lien de parenté",
  "pf_guardian_name": "Tuteur / responsable",
  "pf_guardian_relation": "Lien avec le tuteur",
  "pf_guardian_phone": "Tél. du tuteur",
  "pf_insurer": "Assurance / couverture",
  "pf_policy_no": "N° de police",
  "pf_referred_by": "Adressé par",
  "pf_height": "Taille cm",
  "pf_weight": "Poids kg",
  "pf_smoking": "Tabac",
  "pf_vaccination": "Vaccination",
  "pf_disability": "Handicap",
  "pf_surgeries": "Chirurgies antérieures",
  "pf_family_history": "Antécédents familiaux",
  "marital_single": "Célibataire",
  "marital_married": "Marié(e)",
  "marital_divorced": "Divorcé(e)",
  "marital_widowed": "Veuf/veuve",
  "smoke_never": "Jamais",
  "smoke_former": "Ancien fumeur",
  "smoke_current": "Fumeur",
  "vacc_complete": "Complète",
  "vacc_partial": "Partielle",
  "vacc_none": "Non vacciné",
  "vacc_unknown": "Inconnue",
  "wil_laayoune": "Laâyoune",
  "wil_smara": "Smara",
  "wil_awserd": "Aousserd",
  "wil_dakhla": "Dakhla",
  "wil_bojador": "Boujdour",
  "wil_rabouni": "Rabouni",
  "wil_other": "Autre",
  "consult_prices": "Tarifs des consultations",
  "consult_prices_hint": "Tarif par type de consultation. Ajouté automatiquement à la facture au début de la consultation.",
  "consult_follow_up": "Consultation de suivi",
  "consult_emergency": "Consultation d'urgence",
  "consult_home": "Visite à domicile",
  "not_set": "Sans tarif",
  "role_doctor": "Médecin",
  "role_nurse": "Infirmier/ère",
  "role_receptionist": "Accueil",
  "cat_otc": "Sans ordonnance (OTC)",
  "cat_supplements": "Compléments",
  "cat_first_aid": "Premiers secours",
  "cat_devices": "Matériel médical",
  "cat_baby": "Bébé",
  "cat_cosmetics": "Dermocosmétique",
  "active_ingredient": "Principe actif",
  "dosage": "Dose / posologie",
  "laboratory": "Laboratoire",
  "rx_required": "Sur ordonnance",
  "rx_required_hint": "Médicament soumis à prescription médicale",
  "patients": "Patients",
  "patient": "Patient",
  "add_patient": "Nouveau patient",
  "search_patient": "Rechercher un patient (nom, téléphone, n° dossier)",
  "patients_empty": "Aucun patient pour le moment",
  "file_no": "N° dossier",
  "age": "Âge",
  "years_short": "ans",
  "gender": "Sexe",
  "gender_male": "Homme",
  "gender_female": "Femme",
  "blood_type": "Groupe sanguin",
  "allergies": "Allergies",
  "chronic": "Maladies chroniques",
  "current_meds": "Traitement habituel",
  "name_required": "Le nom est obligatoire",
  "appointments": "Rendez-vous",
  "today_appointments": "Rendez-vous du jour",
  "appointment_saved": "Rendez-vous enregistré",
  "book": "Réserver",
  "time": "Heure",
  "doctor": "Médecin",
  "reason": "Motif",
  "select_patient": "Sélectionnez un patient",
  "queue_empty": "Aucun rendez-vous ce jour",
  "appt_scheduled": "Programmé",
  "appt_waiting": "En attente",
  "appt_in_progress": "En consultation",
  "appt_done": "Terminé",
  "appt_cancelled": "Annulé",
  "check_in": "Arrivé",
  "start_consult": "Consulter",
  "continue": "Continuer",
  "consultation": "Consultation",
  "new_consultation": "Nouvelle consultation",
  "consultations_today": "Consultations aujourd'hui",
  "visits": "Visites",
  "last_visit": "Dernière visite",
  "vitals": "Constantes vitales",
  "vital_temp": "Temp °C",
  "vital_bp": "Tension",
  "vital_pulse": "Pouls",
  "vital_spo2": "SpO₂ %",
  "vital_weight": "Poids kg",
  "vital_height": "Taille cm",
  "vital_glucose": "Glycémie",
  "symptoms": "Symptômes / motif",
  "diagnosis": "Diagnostic",
  "follow_up": "Prochain contrôle",
  "prescription": "Ordonnance",
  "drug": "Médicament",
  "duration": "Durée",
  "finish_visit": "Terminer la visite",
  "services": "Services",
  "services_empty": "Ajoutez des services (consultation, pansement, analyses…) avec leur prix",
  "svc_consultation": "Consultation",
  "svc_procedure": "Pansement / acte",
  "svc_lab": "Analyses",
  "svc_vaccine": "Vaccin",
  "svc_imaging": "Imagerie",
  "svc_other": "Autre",
  "bill_consultation": "Facturer la consultation",
  "billed": "Facturée",
  "add": "Ajouter",
  "pt_history": "Historique",
  "pt_profile": "Fiche",
  "pt_appointments": "Rendez-vous",
  "pt_records": "Analyses et vaccins",
  "result": "Résultat",
  "next_dose": "Prochaine dose / contrôle",
  "rec_lab": "Analyse",
  "rec_vaccine": "Vaccin",
  "rec_imaging": "Imagerie",
  "rec_procedure": "Acte",
  "rec_document": "Document",
  "act_patient.upsert": "Patient enregistré",
  "act_appointment.upsert": "Rendez-vous",
  "act_encounter.upsert": "Consultation",
  "act_record.upsert": "Enregistrement clinique",
  "act_service.upsert": "Service",
  "act_service.delete": "Service supprimé",
  "clock_in": "Pointer l'arrivée",
  "clock_out": "Pointer le départ",
  "clocked_in": "arrivée pointée",
  "clocked_out": "départ pointé",
  "clocked_in_since": "Pointé depuis",
  "clocked_in_now": "Pointé maintenant",
  "clock_days": "Jours pointés",
  "clock_hours": "Heures pointées",
  "clock_records": "Pointages",
  "pin_mode_unlock": "Entrer",
  "pin_mode_clock": "Pointer",
  "pin_clock_hint": "Choisissez votre nom et saisissez votre PIN pour pointer l'arrivée ou le départ",
  "act_attendance.in": "Pointage d'arrivée",
  "act_attendance.out": "Pointage de départ",
  "act_hr.event": "Enregistrement du personnel",
  "act_hr.event.delete": "Enregistrement du personnel supprimé",
  "hr_profile": "Profil",
  "hr_payroll": "Paie",
  "hr_leave": "Absences",
  "hr_attendance": "Présence",
  "hr_history": "Historique",
  "hr_phone": "Téléphone",
  "hr_address": "Adresse",
  "hr_hire_date": "Date d'embauche",
  "hr_birth_date": "Date de naissance",
  "hr_id_number": "Pièce d'identité / ID",
  "hr_salary": "Salaire",
  "hr_salary_type": "Type de salaire",
  "hr_monthly": "Mensuel",
  "hr_daily": "Journalier",
  "hr_weekly": "Hebdomadaire",
  "hr_days_off_month": "Jours de repos par mois",
  "hr_emergency": "Contact d'urgence",
  "hr_notes": "Notes",
  "hr_photo": "Photo",
  "hr_kind_salary": "Paiement du salaire",
  "hr_kind_advance": "Avance / prêt",
  "hr_kind_repay": "Remboursement d'avance",
  "hr_kind_bonus": "Prime",
  "hr_kind_deduction": "Retenue / sanction",
  "hr_kind_day_off": "Jour de repos",
  "hr_kind_sick": "Arrêt maladie",
  "hr_kind_vacation": "Congés",
  "hr_kind_absence": "Absence injustifiée",
  "hr_kind_late": "Retard",
  "hr_debt": "Doit à l'entreprise",
  "hr_month_summary": "Résumé du mois",
  "hr_base": "Salaire de base",
  "hr_bonuses": "Primes",
  "hr_deductions": "Retenues",
  "hr_advances": "Avances",
  "hr_paid": "Payé ce mois-ci",
  "hr_net": "Net à payer",
  "hr_pay_salary": "Payer le salaire",
  "hr_deduct_debt": "Déduire les avances en cours",
  "hr_add_event": "Enregistrer",
  "hr_amount": "Montant",
  "hr_date": "Date",
  "hr_date_to": "Jusqu'au",
  "hr_days": "Jours",
  "hr_note": "Note",
  "hr_used_days_off": "Jours de repos utilisés",
  "hr_sick_days": "Jours d'arrêt maladie",
  "hr_absences": "Absences",
  "hr_vacation_days": "Congés",
  "hr_year": "cette année",
  "hr_month": "ce mois-ci",
  "hr_shifts_month": "Services ce mois-ci",
  "hr_hours_month": "Heures travaillées",
  "hr_last_shift": "Dernier service",
  "hr_on_leave_today": "Absent aujourd'hui",
  "hr_working_today": "Travaille aujourd'hui",
  "hr_total_payroll": "Masse salariale mensuelle",
  "hr_total_debt": "Avances en cours",
  "hr_leave_today": "Absents aujourd'hui",
  "hr_active_staff": "Personnel actif",
  "hr_no_events": "Aucun enregistrement",
  "hr_delete_event": "Supprimer cet enregistrement ?",
  "hr_event_saved": "Enregistrement sauvegardé",
  "hr_salary_paid": "Salaire payé",
  "hr_seniority": "Ancienneté",
  "hr_years": "{n} ans",
  "hr_months": "{n} mois",
  "hr_birthday_soon": "Anniversaire bientôt",
  "hr_calendar": "Calendrier du mois",
  "hr_export": "Exporter la paie",
  "hr_print_payslip": "Bulletin de salaire",
  "hr_payslip": "Bulletin de paie",
  "hr_signature": "Signature",
  "hr_employee": "Employé",
  "hr_employer": "Entreprise",
  "zakat": "Zakat",
  "zakat_desc": "Lorsque la richesse de l'entreprise dépasse le nisab pendant une année lunaire (hawl, 354 jours), 2,5 % sont dus aux pauvres.",
  "zakat_nisab": "Nisab (valeur de 85 g d'or)",
  "zakat_hawl_start": "Début du hawl",
  "zakat_cash": "Espèces en caisse et en banque",
  "zakat_other": "Autres biens commerciaux",
  "zakat_debts": "Dettes à payer (déduites)",
  "zakat_stock": "Valeur du stock (coût)",
  "zakat_receivables": "Créances clients (crédit)",
  "zakat_wealth": "Richesse soumise à la zakat",
  "zakat_due": "Zakat à verser",
  "zakat_rate": "2,5 %",
  "zakat_days_left": "Il reste {n} jours pour compléter le hawl",
  "zakat_complete": "Hawl complété : la zakat est obligatoire",
  "zakat_below": "En dessous du nisab : pas de zakat obligatoire",
  "zakat_projected": "Zakat estimée à la fin du hawl",
  "zakat_reset": "Zakat payée · démarrer un nouveau hawl",
  "zakat_set_start": "Fixer le début à aujourd'hui",
  "zakat_saved": "Données de zakat enregistrées",
  "tb_new": "Nouveau",
  "tb_open": "Ouvrir",
  "tb_delete": "Supprimer",
  "tb_undo": "Annuler",
  "tb_print": "Imprimer",
  "tb_select_row": "Sélectionnez d'abord une ligne",
  "offline_days": "Hors ligne depuis {t}",
  "oldest_pending": "Plus ancien en attente",
  "retry_failed": "Réessayer les erreurs",
  "failed_ops": "Actions rejetées",
  "storage_persist": "Stockage protégé",
  "storage_not_persist": "Stockage non protégé (le navigateur pourrait effacer les données)",
  "sync_retry_in": "Nouvel essai dans {s}s",
  "session_expired_pending": "Session expirée avec {n} modifications en attente. Reconnectez-vous et elles seront envoyées automatiquement.",
  "app_name": "Orbit PMS",
  "tagline": "Ventes, crédit, stock et clients. Fonctionne sans internet.",
  "login_title": "Accéder à la boutique",
  "login_sub": "Le propriétaire se connecte une fois ; le personnel change avec son PIN.",
  "login": "Entrer",
  "email": "E-mail",
  "password": "Mot de passe",
  "no_account": "Pas de compte ?",
  "have_account": "Déjà un compte ?",
  "create_shop": "Créer une boutique",
  "register_sub": "Configurez votre boutique en une minute.",
  "shop_name": "Nom de la boutique",
  "shop_type": "Type de boutique",
  "owner_name": "Nom du propriétaire",
  "owner_pin": "PIN du propriétaire (4 chiffres)",
  "pin_4_digits": "Le PIN doit comporter 4 chiffres",
  "currency": "Devise",
  "type_grocery": "Boutique",
  "type_wholesale": "Grossiste",
  "type_pharmacy": "Pharmacie",
  "need_internet": "Connexion internet requise",
  "loading": "Chargement…",
  "session_expired": "Session expirée. Reconnectez-vous ; vos données sont sauvegardées.",
  "not_allowed": "Votre rôle ne permet pas cette action",
  "sync_failed_ops": "{n} actions rejetées par le serveur",
  "sync_conflicts": "Des conflits de synchronisation sont survenus. Consultez Équipe › Synchronisation.",
  "nav_sell": "Vendre",
  "nav_customers": "Clients",
  "nav_stock": "Stock",
  "nav_reports": "Rapports",
  "nav_more": "Plus",
  "lock": "Verrouiller",
  "synced": "Synchronisé",
  "offline": "Hors ligne",
  "syncing": "Synchronisation",
  "sync_error": "Erreur",
  "pending": "En attente",
  "pin_who": "Qui travaille maintenant ?",
  "pin_wrong": "PIN incorrect",
  "pin_need_sync": "Connectez-vous à internet une fois pour télécharger la boutique.",
  "sign_out_shop": "Déconnecter la boutique",
  "logout_pending_warn": "Des modifications non synchronisées existent sur cet appareil. Quitter quand même ? Elles seront envoyées à la prochaine connexion.",
  "role_owner": "Propriétaire",
  "role_manager": "Gérant",
  "role_cashier": "Caissier",
  "search_products": "Rechercher un produit…",
  "search_customers": "Rechercher un client ou une famille…",
  "all": "Tout",
  "no_products": "Aucun produit pour le moment",
  "cat_food": "Alimentation",
  "cat_grains": "Céréales",
  "cat_drinks": "Boissons",
  "cat_hygiene": "Hygiène",
  "cat_medicine": "Médicaments",
  "cat_household": "Maison",
  "cat_other": "Autres",
  "cart": "Panier",
  "cart_empty": "Touchez un produit pour l'ajouter",
  "clear": "Vider",
  "items": "articles",
  "total": "Total",
  "discount": "Remise",
  "pay_cash": "Espèces",
  "pay_credit": "Crédit",
  "customer_optional": "Client (facultatif, cumule des points)",
  "choose_family_tab": "Choisissez le compte familial",
  "balance_now": "Dette",
  "over_limit": "Dépasse la limite de crédit",
  "cash_given": "Montant reçu",
  "paid_now": "Payé maintenant",
  "exact": "Exact",
  "change": "Monnaie",
  "on_tab": "Sur le compte",
  "confirm_sale": "Confirmer la vente",
  "sale_saved": "Vente enregistrée",
  "receipt": "Reçu",
  "payment": "Paiement",
  "paid": "Payé",
  "customer": "Client",
  "balance_owed": "Doit",
  "thanks": "Merci !",
  "print": "Imprimer",
  "new_sale": "Nouvelle vente",
  "add_customer": "Nouveau client",
  "edit_customer": "Modifier le client",
  "name": "Nom",
  "family": "Famille",
  "phone_whatsapp": "Téléphone / WhatsApp",
  "credit_limit": "Limite de crédit",
  "notes": "Notes",
  "possible_duplicate": "Client peut-être en double",
  "use_this": "Utiliser celui-ci",
  "save_anyway": "Enregistrer quand même",
  "save": "Enregistrer",
  "saved": "Enregistré",
  "total_debt": "Dette totale",
  "filter_all": "Tous",
  "filter_owing": "Avec dette",
  "filter_over_limit": "Au-dessus de la limite",
  "no_customers": "Aucun client",
  "points": "points",
  "repay": "Encaisser",
  "remind": "Rappeler",
  "edit": "Modifier",
  "history": "Historique",
  "no_history": "Aucun mouvement",
  "repayment": "Remboursement de dette",
  "purchase": "Achat",
  "record_repayment": "Enregistrer un paiement",
  "amount": "Montant",
  "confirm": "Confirmer",
  "repayment_saved": "Paiement enregistré",
  "sent": "Envoyé",
  "sent_mocked": "Simulé (MOCKED) : WhatsApp sans clés pour l'instant",
  "tpl_reminder": "Bonjour {name}, nous vous rappelons que votre solde chez {shop} est de {balance}. Merci !",
  "tpl_promo": "Bonjour {name}, nouvelles offres chez {shop} cette semaine ! Nous vous attendons.",
  "tpl_thanks": "Merci {name} de votre confiance en {shop}.",
  "tpl_promo_label": "Offre",
  "tpl_reminder_label": "Rappel de dette",
  "tpl_thanks_label": "Remerciement",
  "add_product": "Nouveau produit",
  "edit_product": "Modifier le produit",
  "alerts": "Alertes",
  "prices": "Prix",
  "low_stock": "Stock bas",
  "expiring_soon": "Expire bientôt",
  "expired": "Expiré",
  "expires": "Expire dans",
  "days_short": "j",
  "all_good": "Tout va bien",
  "category": "Catégorie",
  "icon": "Icône",
  "price": "Prix",
  "cost": "Coût",
  "starting_stock": "Stock initial",
  "low_stock_at": "Alerte à",
  "unit_hint": "kg, carton…",
  "expiry_optional": "Péremption (facultatif)",
  "adjust_stock": "Ajuster le stock",
  "current": "Actuel",
  "stock_updated": "Stock mis à jour",
  "name_price_required": "Le nom et le prix sont obligatoires",
  "confirm_delete": "Supprimer ce produit ?",
  "prices_updated": "{n} prix mis à jour",
  "apply_to": "Appliquer à {n} produits",
  "purchases": "Achats",
  "purchases_desc": "Fournisseurs et entrées de marchandises",
  "new_purchase": "Nouvel achat",
  "suppliers": "Fournisseurs",
  "add_supplier": "Fournisseur",
  "supplier": "Fournisseur",
  "phone": "Téléphone",
  "add_supplier_first": "Ajoutez d'abord un fournisseur",
  "add_product_line": "Ajouter un produit…",
  "pay_supplier": "Payer le fournisseur",
  "supplier_payment": "Paiement fournisseur",
  "supplier_payment_saved": "Paiement fournisseur enregistré",
  "act_supplier_payment.create": "Paiement fournisseur",
  "qty": "Qté",
  "paid_supplier": "Payé au fournisseur",
  "save_purchase": "Enregistrer l'achat",
  "purchase_saved": "Achat enregistré",
  "no_suppliers": "Aucun fournisseur",
  "we_owe": "Nous devons",
  "marketing": "Marketing",
  "marketing_desc": "WhatsApp, offres et points",
  "whatsapp": "WhatsApp",
  "promotions": "Offres",
  "seg_all": "Tous",
  "seg_debtors": "Avec dette",
  "seg_loyal": "Fidèles",
  "seg_inactive": "Inactifs 30j",
  "no_phone": "sans téléphone",
  "message": "Message",
  "send_whatsapp": "Envoyer à {n}",
  "whatsapp_mocked_note": "WhatsApp est en mode simulé (MOCKED) jusqu'à l'ajout des clés Twilio.",
  "promo_name": "Nom de l'offre",
  "loyalty_note": "Fidélité : 1 point pour {n} dépensés.",
  "reports_desc": "Ventes, dettes et meilleures ventes",
  "range_1": "Aujourd'hui",
  "range_7": "7 jours",
  "range_30": "30 jours",
  "sales": "Ventes",
  "cash_in": "Entrée de caisse",
  "new_credit": "Nouveau crédit",
  "repayments": "Remboursements de dettes",
  "units_sold": "Unités vendues",
  "units_bought": "Unités achetées",
  "sales_by_day": "Ventes par jour",
  "top_sellers": "Meilleures ventes",
  "top_debtors": "Plus grosses dettes",
  "team": "Équipe",
  "team_desc": "Personnel, PIN et journal d'activité",
  "staff": "Personnel",
  "activity": "Activité",
  "sync_issues": "Synchronisation",
  "add_staff": "Nouvel employé",
  "edit_staff": "Modifier l'employé",
  "role": "Rôle",
  "pin": "PIN (4 chiffres)",
  "new_pin_optional": "Nouveau PIN (facultatif)",
  "active": "Actif",
  "inactive": "Inactif",
  "clear_failed": "Effacer les erreurs",
  "no_conflicts": "Aucun conflit",
  "conflict_price": "Conflit de prix",
  "conflict_duplicate_customer": "Client en double",
  "conflict_price_detail": "Serveur : {server} · Appareil : {device} · Conservé : {kept}",
  "conflict_dup_detail": "Ressemble à : {name}",
  "kept_server": "serveur (plus récent)",
  "kept_device": "appareil (plus récent)",
  "act_sale_create": "",
  "act_sale.create": "Vente",
  "act_customer.upsert": "Client enregistré",
  "act_payment.create": "Remboursement de dette",
  "act_product.upsert": "Produit enregistré",
  "act_product.delete": "Produit supprimé",
  "act_stock.adjust": "Ajustement de stock",
  "act_price.bulk": "Modification groupée des prix",
  "act_supplier.upsert": "Fournisseur enregistré",
  "act_purchase.create": "Achat",
  "act_promotion.upsert": "Offre enregistrée",
  "act_shop.update": "Paramètres de la boutique",
  "act_staff.create": "Employé créé",
  "act_staff.update": "Employé modifié",
  "act_campaign.send": "Campagne WhatsApp",
  "settings": "Paramètres",
  "settings_desc": "Langue, synchronisation et sauvegardes",
  "language": "Langue",
  "sync": "Synchronisation",
  "last_sync": "Dernière synchronisation",
  "sync_now": "Synchroniser maintenant",
  "simulate_offline": "Simuler hors ligne",
  "shop_settings": "Informations de la boutique",
  "address": "Adresse / camp",
  "loyalty_per": "Dépense par point",
  "low_stock_default": "Alerte de stock par défaut",
  "backup_export": "Sauvegarde",
  "export_device": "Exporter les données de l'appareil (JSON)",
  "export_server": "Exporter la copie du serveur (JSON)",
  "export_debts_csv": "Exporter les dettes (CSV)",
  "admin_title": "Panneau SaaS",
  "welcome": "Bienvenue",
  "dashboard": "Tableau de bord",
  "scan": "Scanner",
  "scan_barcode": "Scanner le code-barres",
  "camera_error": "Impossible d'ouvrir la caméra. Saisissez le code ou utilisez un lecteur USB.",
  "manual_code": "Saisissez ou scannez le code…",
  "barcode": "Code-barres",
  "batch": "Lot",
  "generate": "Générer",
  "not_found_barcode": "Produit introuvable",
  "labels": "Étiquettes",
  "print_labels": "Imprimer les étiquettes",
  "copies": "Copies",
  "no_barcode_n": "{n} produits sans code-barres",
  "generate_barcodes": "Générer les codes",
  "barcodes_generated": "{n} codes générés",
  "sales_history": "Historique des ventes",
  "sales_history_desc": "Reçus, réimpression et retours",
  "receipt_no": "N° reçu",
  "no_sales": "Aucune vente",
  "return_items": "Retour",
  "refund": "Remboursement",
  "refund_cash": "En espèces",
  "refund_credit": "Déduire de la dette",
  "return_saved": "Retour enregistré",
  "returned": "Retourné",
  "expenses": "Dépenses",
  "expenses_desc": "Loyer, transport, groupe électrogène…",
  "add_expense": "Ajouter une dépense",
  "expense_saved": "Dépense enregistrée",
  "note": "Note",
  "exp_rent": "Loyer",
  "exp_transport": "Transport",
  "exp_power": "Électricité / groupe électrogène",
  "exp_water": "Eau",
  "exp_salaries": "Salaires",
  "exp_other": "Autres",
  "pdf_reports": "Rapports PDF",
  "pdf_sales": "Ventes",
  "pdf_top": "Meilleures ventes",
  "pdf_pnl": "Pertes et profits",
  "pdf_stock": "Inventaire",
  "pdf_low": "Stock bas",
  "pdf_expiry": "Péremptions",
  "pdf_debts": "Dettes clients",
  "pdf_purchases": "Achats",
  "pdf_expenses": "Dépenses",
  "pdf_statement": "Relevé de compte (PDF)",
  "generating": "Génération du PDF…",
  "generated_at": "Généré le",
  "period": "Période",
  "revenue": "Recettes",
  "cogs": "Coût des ventes",
  "gross_profit": "Bénéfice brut",
  "net_profit": "Bénéfice net",
  "date": "Date",
  "product": "Produit",
  "stock_value": "Valeur du stock",
  "act_sale.return": "Retour",
  "act_expense.create": "Dépense",
  "modules": "Modules",
  "modules_sub": "Tous les outils de votre boutique en un geste.",
  "sell_desc": "Caisse rapide, espèces et crédit",
  "customers_desc": "Comptes familiaux et paiements",
  "stock_desc": "Produits, alertes et prix",
  "hero_title": "Votre boutique, organisée. Avec ou sans internet.",
  "feat_offline": "Fonctionne hors ligne",
  "feat_offline_desc": "Vendez et notez les dettes sans réseau ; tout se synchronise au retour.",
  "feat_credit": "Comptes familiaux",
  "feat_credit_desc": "Crédit, paiements et historique de chaque famille en un geste.",
  "feat_whatsapp": "Clients par WhatsApp",
  "feat_whatsapp_desc": "Offres et rappels aux clients de votre choix.",
  "stores": "Boutiques",
  "active_30d": "Actives 30j",
  "sales_30d": "Ventes 30j",
  "products_count": "Produits",
  "last_sync_col": "Sync.",
  "nav_modules": "Modules",
  "nav_ai": "IA",
  "nav_multi": "Multi",
  "nav_cloud": "Cloud",
  "nav_tech": "Technologie",
  "landing_modules_title": "Bien plus qu'une caisse enregistreuse",
  "landing_modules_q": "Si vous pouvez tout avoir...",
  "landing_modules_q2": "Pourquoi se contenter de moins ?",
  "ai_soon": "Bientôt disponible",
  "ai_title": "Orbit + Intelligence Artificielle =",
  "ai_text": "Nour sera l'assistante de votre boutique : demandez-lui dans votre langue combien vous avez vendu aujourd'hui, qui doit le plus ou quel produit s'épuise.",
  "ai_text2": "Nous la préparons aussi pour vous guider à la voix, pour ceux qui préfèrent parler plutôt qu'écrire.",
  "multi_kicker": "Pour tous",
  "multi_title": "Concept « Multi »",
  "multi_text": "Conçu dès le départ pour des boutiques différentes, des personnes différentes et des connexions difficiles.",
  "multi_lang": "Multilingue : arabe, espagnol et français",
  "multi_role": "Multi-utilisateur : propriétaire, gérant et caissier avec PIN",
  "multi_device": "Multi-appareil : téléphone simple, tablette ou ordinateur",
  "multi_type": "Multi-activité : boutique, grossiste et pharmacie",
  "diff_kicker": "Tous les TPV ne se valent pas",
  "diff_text": "Orbit est né dans les camps : grands boutons, icônes claires, écriture de droite à gauche et aucune dépendance au réseau. Découvrez ce qui le rend différent.",
  "saas_text": "Il vous suffit d'un navigateur. Orbit s'installe comme une app sur votre téléphone et continue de fonctionner même sans internet.",
  "saas_offline": "Système distribué : chaque téléphone conserve ses ventes et ses dettes, et se synchronise avec le cloud au retour de la connexion, sans rien perdre.",
  "saas_secure": "Vos données restent dans le cloud, séparées par boutique, et vous pouvez les exporter quand vous voulez en JSON ou CSV.",
  "tech_code": "React et une PWA avec IndexedDB sur le téléphone ; FastAPI et MongoDB sur le serveur. Codes-barres, étiquettes et PDF sont générés sur l'appareil lui-même.",
  "tech_platform": "Une file d'opérations synchronise par lots, résout les conflits de prix et signale les clients en double pour que rien ne se perde.",
  "footer_note": "Conçu pour les boutiques des camps sahraouis.",
  "back_top": "Retour en haut",
  "scale": "Balance",
  "scale_connect": "Connecter la balance",
  "scale_disconnect": "Déconnecter la balance",
  "scale_live": "Balance en direct",
  "scale_sim": "Balance simulée",
  "scale_manual": "Poids manuel",
  "scale_stable": "Poids stable",
  "scale_settling": "Stabilisation…",
  "scale_tare": "Tare",
  "scale_clear_tare": "Retirer la tare",
  "scale_type_weight": "Saisissez le poids",
  "scale_unsupported": "Ce navigateur ne peut pas connecter de balance. Utilisez Chrome ou Edge sur ordinateur, ou saisissez le poids.",
  "scale_not_connected": "Non connectée",
  "scale_and_scanner": "Balance et lecteur",
  "scale_device_hint": "Connectez la balance en USB/série (CAS, Dibal, Mettler…). Les lecteurs de codes USB ou Bluetooth fonctionnent seuls dans Vendre, Stock et Achats.",
  "scale_baud": "Vitesse (bauds)",
  "scale_poll": "Commande de demande de poids (facultatif)",
  "scale_simulator": "Mode test (balance simulée)",
  "scale_simulator_hint": "Pour tester sans balance réelle",
  "scale_label_carries": "L'étiquette de la balance contient",
  "weight": "Poids",
  "scale_prefix": "Préfixe",
  "price_decimals": "Décimales du prix",
  "round_to": "Arrondir à",
  "scale_prefix_invalid": "Le préfixe doit être compris entre 20 et 29",
  "sold_by_weight": "Vendu au poids",
  "sold_by_weight_hint": "Le prix est au kg et le produit est pesé à la vente",
  "price_per_kg": "Prix au kg",
  "plu": "PLU (code balance)",
  "add_to_cart": "Ajouter au panier",
  "weigh_label": "Peser et étiqueter",
  "create_label": "Créer l'étiquette",
  "no_weighed_products": "Aucun produit au poids. Activez « Vendu au poids » sur un produit.",
  "scale_label_too_big": "Valeur trop grande pour l'étiquette",
  "shift": "Service",
  "open_shift": "Ouvrir le service",
  "close_shift": "Clôturer le service",
  "shift_open_since": "Service ouvert depuis",
  "no_shift": "Aucun service",
  "no_shift_banner": "Aucun service ouvert. Ouvrez la caisse pour pouvoir encaisser.",
  "opening_float": "Fonds de caisse initial",
  "cash_out": "Sortie de caisse",
  "counted_cash": "Espèces comptées",
  "expected_cash": "Espèces attendues",
  "difference": "Écart",
  "z_report": "Rapport Z",
  "x_report": "Rapport X",
  "print_z": "Imprimer le rapport Z",
  "shift_history": "Services précédents",
  "sales_count": "Nb de ventes",
  "gross_sales": "Ventes brutes",
  "net_sales": "Ventes nettes",
  "cash_sales": "Ventes en espèces",
  "credit_sales": "Ventes à crédit",
  "credit_paid_now": "Payé sur ventes à crédit",
  "credit_given": "Nouveau crédit",
  "debt_payments": "Remboursements de dettes",
  "cash_refunds": "Remboursements en espèces",
  "returns_total": "Retours",
  "drawer_opens": "Ouvertures du tiroir",
  "open_drawer": "Ouvrir le tiroir",
  "customer_display": "Écran client",
  "price_check": "Vérificateur de prix",
  "price_check_hint": "Passez le code-barres devant le lecteur",
  "price_check_exit": "Quitter (PIN du personnel)",
  "wrong_pin": "PIN incorrect",
  "in_stock": "Disponible",
  "out_of_stock": "Épuisé",
  "offer": "Offre",
  "sc_help": "Aide",
  "sc_search": "Rechercher",
  "sc_scan": "Caméra",
  "sc_modules": "Aller au module",
  "sc_delete_line": "Supprimer la ligne",
  "shortcuts": "Raccourcis clavier",
  "tpv_terminal": "Terminal TPV",
  "tpv_printer_hint": "Utilisez une imprimante thermique 80 mm installée sur l'ordinateur. Activez « ouvrir le tiroir à l'impression » dans son pilote.",
  "auto_print": "Imprimer le ticket automatiquement",
  "auto_print_hint": "À la confirmation de chaque vente",
  "drawer_on_cash": "Ouvrir le tiroir pour les ventes en espèces",
  "drawer_on_cash_hint": "Imprime un mini-ticket pour ouvrir le tiroir",
  "fullscreen": "Plein écran",
  "display_welcome": "Bienvenue !",
  "display_thanks": "Merci de votre achat !",
  "scan_here": "Scannez votre produit ici",
  "qty_key": "Quantité",
  "selected_line": "Ligne",
  "shift_opened": "Service ouvert",
  "shift_closed": "Service clôturé",
  "move_saved": "Mouvement enregistré",
  "scale_preset": "Modèle de balance",
  "scale_presets_hint": "Réglages courants ; vérifiez avec le manuel de votre balance.",
  "scale_format": "Format des données",
  "scale_raw": "Données reçues (en direct)",
  "scale_send_poll": "Demander le poids",
  "scale_autodetect": "Détecter la vitesse",
  "scale_detecting": "Test en cours",
  "scale_detect_found": "Détecté : {v}",
  "scale_detect_none": "Aucun poids reçu. Vérifiez le câble et la commande de demande.",
  "scale_pick_port": "Choisir le port",
  "scale_calibration": "Vérification avec un poids connu",
  "scale_known_weight": "poids étalon",
  "scale_cal_ok": "Correct",
  "scale_cal_bad": "Hors tolérance",
  "hold": "Mettre en attente",
  "recall": "Reprendre",
  "held_sales": "Ventes en attente",
  "no_held": "Aucune vente en attente",
  "held_saved": "Vente mise en attente",
  "recalled": "Vente reprise",
  "line_disc": "% ligne",
  "set_price": "Prix",
  "ticket_disc": "% ticket",
  "manager_pin": "PIN du gérant",
  "manager_pin_hint": "Un gérant ou le propriétaire doit autoriser cette modification.",
  "touch_mode": "Mode écran tactile",
  "touch_hint": "Boutons et textes agrandis pour les écrans tactiles de comptoir.",
  "touch_auto": "Automatique",
  "touch_on": "Activé",
  "touch_off": "Désactivé",
  "keyboard": "Clavier à l'écran",
  "tpv_section": "TPV",
  "tpv_section_desc": "Centre de contrôle du terminal : service, caisse, tiroir, écrans, balance et imprimante",
  "tpv_operations": "Opérations du terminal",
  "open_till": "Ouvrir la caisse / Vendre",
  "z_history": "Rapports Z",
  "no_closed_shifts": "Aucun service clôturé pour le moment",
  "today_sales": "Ventes du jour",
  "back": "Retour",
  "columns": "Colonnes",
  "qa_hint": "Épinglez des boutons du ruban (clic droit)",
  "qa_pin": "Épingler en accès rapide",
  "qa_unpin": "Retirer de l'accès rapide",
  "qa_unpin_hint": "clic droit pour retirer",
  "reset_layout": "Réinitialiser les colonnes",
  "invoices": "Factures",
  "no_invoices": "Aucune facture jointe",
  "without_invoice": "Sans facture",
  "stock": "Stock",
  "expiry": "Péremption",
  "last_purchase": "Dernier achat",
  "balance": "Solde",
  "load": "Charger",
  "filters": "Filtres",
  "date_range": "Période",
  "no_results": "Aucun résultat",
  "records": "enregistrements",
  "photo": "Photo du produit",
  "shop_logo": "Logo de la boutique",
  "photo_hint": "Réduite avant l'envoi pour économiser les données",
  "remove_photo": "Retirer",
  "upload_offline": "Une connexion est nécessaire pour envoyer des fichiers",
  "upload_done": "Fichier envoyé",
  "attach_invoice": "Joindre facture / reçu",
  "replace_attachment": "Remplacer la pièce jointe",
  "view": "Voir",
  "rb_config": "Configuration",
  "rb_sales": "Ventes et TPV",
  "rb_stock": "Entrepôt",
  "rb_customers": "Clients",
  "err_owner_only": "Seul le propriétaire peut faire cette opération", "err_forbidden": "Votre rôle ne le permet pas", "err_amount_positive": "Le montant doit être supérieur à 0", "err_supplier_missing": "Fournisseur introuvable", "err_return_amount": "Montant de retour invalide", "err_order_items": "La commande n'a pas de lignes", "err_bad_status": "Statut invalide", "err_vault_balance": "Solde insuffisant en caisse d'administration", "err_transfer_amount": "Le transfert doit égaler l'espèce comptée moins le fonds de caisse", "err_transfer_kind": "Le transfert de clôture doit être un dépôt", "err_already_open": "Il y en a déjà un ouvert", "err_already_closed": "Déjà fermé", "err_already_invoiced": "Ce ticket a déjà une facture", "err_shift_missing": "Service fermé introuvable", "err_shift_open": "Un autre service est ouvert sur cette caisse", "err_stock": "Stock insuffisant", "err_server": "Erreur serveur ; nouvelle tentative", "err_missing_field": "Champ {f} manquant",
  "remote_display": "Écran client sur un autre appareil", "remote_display_hint": "Ouvrez ce lien sur une tablette ou une TV connectée : il affichera en direct la même chose que l'écran client de cette caisse.", "pairing_code": "Code d'appairage", "copy_link": "Copier le lien", "display_paired": "Connecté", "display_lost": "Connexion à la caisse perdue", "copied": "Copié",
  "display_ads": "Images promotionnelles sur l'écran client", "display_ads_hint": "Affichées en rotation (6 s) quand aucune vente n'est en cours, sur l'écran local et distant.", "scan_to_pair": "scannez le QR avec la tablette",
  "pay_advance": "Acompte", "pay_transfer": "Virement", "pay_with_advance": "Payer avec l'acompte", "advance_applied": "Acompte appliqué", "advance_rest_debt": "Le reste devient une dette", "fin_refund": "Rembourser l'acompte", "fin_refund_hint": "Rend au client de l'argent de son solde créditeur (sort de la caisse).", "fin_exceeds_advance": "Le montant dépasse l'acompte disponible", "fin_invoice_manual": "Facture manuelle", "fin_concept": "Libellé", "fin_concept_ph": "Service, produit, transport…", "fin_add_line": "Ajouter une ligne", "fin_add_lines": "Ajoutez au moins une ligne", "fin_lines": "lignes", "fin_method_needs_customer": "Ce mode de paiement nécessite un client", "fin_no_advance": "Le client n'a pas d'acompte disponible", "advance_sales": "Payé par acompte",
  "display_idle_hint": "Approchez-vous de la caisse : vos achats s'affichent ici en direct",
  "np_title": "Bénéfice net", "np_today": "Aujourd'hui", "np_week": "Cette semaine", "np_month": "Ce mois", "np_total": "Total historique", "np_margin": "Marge", "np_by_day": "Par jour (30)", "np_by_week": "Par semaine (12)", "np_by_month": "Par mois (12)", "np_period": "Période",
  "perm_title": "Permissions", "perm_hint": "Désactivez n'importe quelle fonction pour cet utilisateur. Un module désactivé disparaît de son menu. Les blocages s'appliquent aussi côté serveur.", "perm_all_on": "Tout", "perm_all_off": "Rien", "perm_blocked": "bloquées",
  "perm_sell": "Ventes et caisse", "perm_returns": "Retours et annulations", "perm_customers": "Clients et encaissements", "perm_inventory": "Produits et stock", "perm_purchases": "Achats, dépenses et fournisseurs", "perm_marketing": "Promotions", "perm_reports": "Rapports et clôture", "perm_clinic": "Agenda clinique", "perm_patients": "Patients", "perm_medical": "Dossier médical",
  "act_shift.open": "Ouvrir un service", "act_shift.close": "Fermer le service", "act_cash.move": "Entrées/sorties de caisse", "act_vault.move": "Mouvements caisse administration", "act_invoice.create": "Émettre une facture", "act_invoice.void": "Annuler une facture", "act_house.open": "Ouvrir période compte maison", "act_house.close": "Fermer période compte maison", "act_day.close": "Clôturer le jour",
  "admin_control": "Contrôle", "admin_features": "Fonctions du magasin", "admin_staff": "Utilisateurs du magasin", "admin_features_hint": "Bloquez des modules ou actions pour TOUT le magasin (propriétaire inclus). Appliqué côté serveur et application.", "enable_label": "Activer", "tab_features": "Fonctions", "tab_staff": "Utilisateurs magasins", "tab_danger": "Suspendre/supprimer",
  "operated_by": "Opéré par", "friday_lock": "Pause pour la prière du vendredi", "friday_lock_hint": "Une demi-heure avant la prière, le système se verrouille pendant la durée indiquée. Dès 4 heures avant, il prévient toutes les demi-heures.", "friday_prayer_time": "Heure de la prière", "friday_lock_minutes": "Durée du verrouillage (min)", "friday_warn": "Prière du vendredi : le système se verrouillera dans {time}", "friday_title": "Pause pour la prière du vendredi", "friday_body": "صلاة الجمعة · Le système est en pause. Retour après la prière.", "friday_until": "Reprise à", "friday_locked_by": "Verrouillage automatique configuré par l'administrateur", "friday_override": "Déverrouiller (propriétaire)",
  "friday_auto": "Calculer automatiquement selon la ville", "friday_auto_hint": "Heure du Dhuhr calculée par position solaire (hors ligne) + marge en minutes pour la khutba.", "friday_city": "Ville", "friday_custom_coords": "Coordonnées personnalisées", "friday_offset": "Marge après le Dhuhr (min)", "friday_next": "Vendredi prochain", "dhuhr": "Dhuhr", "use_my_location": "Utiliser ma position", "geo_failed": "Position indisponible", "city_rabouni": "Rabouni (camps)", "city_tindouf": "Tindouf", "city_bechar": "Béchar", "city_algiers": "Alger", "city_oran": "Oran", "city_constantine": "Constantine", "city_tlemcen": "Tlemcen", "city_ouargla": "Ouargla", "city_laayoune": "Laâyoune", "city_nouakchott": "Nouakchott", "city_madrid": "Madrid",
  "type_exchange": "Bureau de change", "fx_board_note": "Message sur l'écran client", "fx_show_board": "Afficher le tableau sur l'écran client", "fx_board_footer": "Taux indicatifs · susceptibles de changer sans préavis", "fx_board_idle": "Présentez-vous au comptoir pour changer", "fx_import_statement": "Importer un relevé", "fx_import_pick": "Choisir le CSV de la banque", "fx_import_hint": "CSV exporté de la banque en ligne (Date · Libellé · Montant). Seuls les crédits sont utilisés.", "fx_csv_empty": "Aucun crédit trouvé dans le fichier", "fx_csv_matched": "Correspondances", "fx_csv_new": "Nouveaux", "fx_csv_skipped": "Ignorés", "fx_csv_result": "Résultat", "fx_csv_create": "Créer et rapprocher", "fx_csv_skip": "Ignorer", "fx_csv_unmatch": "Dissocier", "fx_csv_apply": "Rapprocher {n} virements", "fx_csv_done": "{n} virements rapprochés", "fx_csv_imported": "Importé du relevé", "fx_concept": "Libellé", "fx_fondo_dzd": "Fonds DZD", "fx_fondo_hint": "Les achats de devises consomment le fonds ; les ventes l'alimentent", "fx_fondo_open": "Ouverture", "fx_fondo_close": "Clôture", "fx_fondo_short": "Fonds DZD insuffisant ({n})", "fx_given": "remis", "fx_received": "reçu", "fx_registers_hint": "Chaque opération est versée automatiquement dans la caisse de sa banque (ou espèces) avec l'équivalent DZD remis ; incluse dans la clôture du jour.", "fx_transfers": "Virements reçus", "fx_report_transfer": "Déclarer un virement", "fx_reconcile": "Rapprocher", "fx_reconciled": "Rapproché", "fx_unreconcile": "Annuler le rapprochement", "fx_apply_exchange": "Appliquer au change", "fx_applied_to": "Appliqué à", "fx_tf_open": "Non appliqué", "fx_tf_unreconciled": "Non rapproché", "fx_tf_applied": "Appliqué", "fx_reference": "Référence", "fx_value_date": "Date de valeur", "fx_sender_required": "Indiquez l'expéditeur", "fx_fee": "Commission", "fx_daily_summary": "Résumé du jour par devise", "fx_bought": "Acheté", "fx_sold": "Vendu", "fx_in": "entrée", "fx_out": "sortie", "fx_bank_transfer": "Virement bancaire", "fx_sender": "Expéditeur (envoie)", "fx_receiver": "Bénéficiaire (reçoit)", "fx_pin_hint": "Un PIN à 6 chiffres sera généré. Le bénéficiaire doit le présenter pour recevoir les espèces au taux de change.", "fx_pickup_pin": "PIN de retrait", "fx_pending_pickups": "En attente de remise", "fx_pay_out": "Remettre les espèces", "fx_paid_out": "Remis", "fx_pending": "En attente", "fx_wrong_pin": "PIN incorrect", "fx_sender_receiver_required": "Indiquez l'expéditeur et le bénéficiaire", "fx_bank_balances": "Soldes bancaires", "fx_desc": "Achat et vente d'EUR, USD… en DZD", "fx_rates": "Taux de change", "fx_we_buy": "Nous achetons", "fx_we_sell": "Nous vendons", "fx_spread": "Marge", "fx_buy_from_client": "Achat au client (devise entre)", "fx_sell_to_client": "Vente au client (devise sort)", "fx_rate": "Taux", "fx_pay_client": "Payer au client", "fx_receive_client": "Encaisser du client", "fx_id_doc": "Document (CNI/Passeport)", "fx_id_required": "À partir de {n} en devise, nom et document du client requis", "fx_insufficient": "Pas assez de {c} en caisse", "fx_position": "Position", "fx_profit": "Bénéfice de marge", "fx_cash_positions": "Espèces par devise", "fx_adjust_float": "Ajuster le fonds", "fx_float_in": "Entrée de fonds", "fx_float_out": "Sortie de fonds", "fx_ledger": "Opérations", "fx_id_threshold": "Seuil d'identification (devise)",
  "rb_finance": "Facturation et Finances", "grp_invoicing": "Facturation", "grp_collections": "Encaissements", "grp_production": "Production", "grp_registers": "Caisses",
  "fin_cash_journal": "Journal des caisses", "fin_house_register": "Caisse Intégrations", "fin_invoices": "Factures", "fin_invoice": "Facture", "fin_invoice_new": "Facturer", "fin_day_close": "Clôture du jour", "fin_collections": "Encaissements",
  "fin_register": "Caisse", "fin_reg_admin": "Administration", "fin_reg_integrations": "Intégrations (compte maison)", "fin_reg_tpv": "TPV", "fin_open": "Ouverte", "fin_closed": "Fermée", "fin_open_data": "Données d'ouverture", "fin_close_data": "Données de clôture",
  "fin_transfer": "Transférer", "fin_new_shift": "Nouveau service", "fin_revert_close": "Annuler la clôture", "fin_revert_confirm": "Le service sera rouvert et son transfert vers la caisse d'administration annulé. Continuer ?", "fin_reopened": "Clôture annulée",
  "fin_house_desc": "La Caisse Intégrations enregistre tout ce qui sort du magasin sans encaissement : consommation du propriétaire, cadeaux à sa famille, au personnel et à leurs familles (ventes en « Compte maison »). Ouvrez une période, cumulez les mouvements puis fermez-la pour obtenir le bilan au coût et au prix par bénéficiaire.",
  "fin_open_since": "Ouverte depuis", "fin_close_period": "Fermer la période", "fin_open_period": "Ouvrir une période", "fin_no_open_period": "Aucune période ouverte : les nouvelles consommations restent à affecter.", "fin_period_moves": "Mouvements de la période", "fin_unassigned_moves": "Mouvements sans période", "fin_period_history": "Historique des périodes", "fin_house_opened": "Période ouverte", "fin_house_closed": "Période fermée",
  "fin_pick_sales": "Sélectionnez au moins un ticket", "fin_customer_required": "Indiquez le client", "fin_invoice_created": "Facture émise", "fin_invoice_voided": "Facture annulée", "fin_tax_id": "NIF / RC", "fin_search_sales": "Rechercher un ticket ou un client…", "fin_no_sales_to_invoice": "Aucun ticket à facturer", "fin_issue_invoice": "Émettre la facture", "fin_no_invoices": "Aucune facture", "fin_void_invoice": "Annuler la facture", "fin_inv_issued": "Émise", "fin_inv_void": "Annulée", "fin_invoice_footer": "Facture sans TVA · Document généré par Orbit PMS",
  "fin_day_closed": "Jour clôturé", "fin_day_is_closed": "Jour clôturé", "fin_close_day": "Clôturer le jour", "fin_production_balance": "Bilan de production", "fin_sales_by_method": "Ventes par mode de paiement", "fin_registers": "Caisses", "fin_cash_diff": "Écarts de caisse", "fin_history": "Historique", "fin_season": "Saison", "fin_reopened_status": "Rouvert",
  "fin_advances_held": "Acomptes en dépôt", "fin_collect": "Encaissement de dette", "fin_advance": "Acompte", "fin_collect_hint": "Encaissez tout ou partie de la dette d'un client.", "fin_advance_hint": "Argent versé d'avance par le client ; reste à son crédit et se déduit de ses prochains achats à crédit.", "fin_exceeds_debt": "Le montant dépasse la dette",
  "returns": "Retours",

  "rb_reports": "Analyse et Reporting",
  "grp_config": "Configuration",
  "grp_data": "Données",
  "grp_stores": "Boutiques",
  "grp_operations": "Opérations",
  "grp_stock": "Entrepôt",
  "grp_customers": "Clients",
  "grp_analysis": "Analyse",
  "tpv_store": "TPV Boutique",
  "tickets": "Tickets",
  "cash_count": "Comptage de caisse",
  "analysis": "Analyse",
  "tpv_settings_moved": "Paramètres TPV, imprimante, tiroir, tactile et balance → section TPV",
  "tm_terminal": "Terminal",
  "tm_open_terminals": "Terminaux ouverts",
  "tm_date": "Date",
  "tm_store": "Boutique",
  "tm_pos": "Point de vente",
  "tm_add": "Nouveau terminal",
  "tm_open": "Ouvrir",
  "tm_customer_id": "Identité clients",
  "tm_account": "Compte",
  "tm_ticket": "Ticket",
  "tm_article": "Article",
  "tm_lock": "Verrouiller le terminal",
  "tm_exit": "Quitter le terminal",
  "tm_accounts": "Comptes",
  "tm_funds": "Fonds",
  "tm_services": "Consommation services",
  "tm_arqueo": "Comptage",
  "tm_menu": "Menu",
  "tm_last_ticket": "Imprimer le dernier ticket",
  "tm_proforma": "Imprimer la proforma",
  "tm_choose": "Choisissez un article pour créer un nouveau compte",
  "tm_tot": "Tot.",
  "tm_pending": "Att.",
  "tm_advanced": "Encaissement avancé",
  "tm_cash": "Espèces",
  "tm_card": "Carte",
  "tm_credit": "Crédit client",
  "tm_line_note": "Note ligne",
  "tm_line_price": "Prix ligne",
  "tm_void_line": "Annuler la ligne",
  "tm_reduce": "Réduire la quantité",
  "tm_clear": "Effacer",
  "tm_enter": "Entrée",
  "tm_type_first": "Saisissez d'abord le prix au clavier",
  "tm_select_line": "Sélectionnez une ligne",
  "tm_no_ticket": "Aucun ticket",
  "tm_parked": "Compte enregistré",
  "tm_touch": "Terminal tactile",
  "pay_card": "Carte",
  "card_sales": "Ventes par carte",
  "pay_split": "Paiement partagé",
  "pay_house": "Compte maison", "house_sales": "Consommation maison (sans encaissement)", "house_hint": "Produits consommés par le propriétaire ou offerts à sa famille, au personnel ou à leurs familles. Aucun argent n'entre en caisse ; déduit du stock.", "house_for": "Pour qui", "house_owner": "Propriétaire", "house_owner_family": "Famille du propriétaire", "house_staff": "Personnel", "house_staff_family": "Famille du personnel", "house_note": "Note d'utilisation", "house_note_ph": "Ex. : petit-déjeuner du personnel, cadeau de l'Aïd…", "house_total": "Consommation maison", "house_cost": "Consommation maison (au coût)", "house_gate_note": "Le PIN d'un responsable est requis pour confirmer.",
  "split_sales": "Ventes à paiement partagé",
  "tm_split": "Partager",
  "split_title": "Partager le paiement",
  "split_cash": "Espèces reçues",
  "split_card": "Carte",
  "split_credit": "À crédit", "split_debt": "Dette", "split_rest_debt": "Reste en dette", "split_debt_over": "La dette dépasse le total",
  "split_rest_cash": "Reste en espèces",
  "split_rest_card": "Reste par carte",
  "split_need_customer": "Choisissez un client pour enregistrer le reste en dette",
  "split_card_over": "La carte dépasse le total",
  "fav_edit": "Modifier les favoris",
  "fav_new_page": "Nouvelle page",
  "fav_page_name": "Nom de la page",
  "fav_add_products": "Ajouter des produits",
  "fav_empty": "Page vide : appuyez sur Modifier les favoris pour ajouter des produits",
  "fav_saved": "Favoris enregistrés",
  "fav_delete_page": "Supprimer la page",
  "act_favorites.update": "Favoris",
  "billing": "Abonnement",
  "plan_free": "Gratuit",
  "plan_pro": "Pro",
  "plan_business": "Business",
  "plan": "Forfait",
  "status": "Statut",
  "ends": "Fin",
  "manage": "Gérer",
  "plan_status_trial": "Essai gratuit",
  "plan_status_active": "Actif",
  "plan_status_expired": "Expiré",
  "plan_status_free": "Gratuit",
  "plan_status_suspended": "Suspendue",
  "current_plan": "Forfait actuel",
  "trial_days_left": "Il reste {n} jours d'essai",
  "plan_expires_on": "Valable jusqu'au {d}",
  "trial_over": "Votre essai est terminé : vous êtes maintenant sur le forfait Gratuit",
  "usage": "Utilisation",
  "limit_products": "Produits",
  "limit_staff": "Employés",
  "limit_devices": "Appareils",
  "unlimited": "Illimité",
  "per_month": " /mois",
  "price_tbd": "[prix à définir]",
  "request_plan": "Demander ce forfait",
  "months": "Mois",
  "pay_method": "Mode de paiement",
  "method_cash": "Espèces",
  "method_transfer": "Virement bancaire",
  "pay_reference": "Référence du paiement (facultatif)",
  "send_request": "Envoyer la demande",
  "request_sent": "Demande envoyée. L'administrateur activera votre forfait à réception du paiement.",
  "request_pending": "Vous avez déjà une demande en attente",
  "how_to_pay": "Comment payer",
  "pay_instructions_default": "[Coordonnées bancaires / point de paiement à définir par l'administrateur]",
  "plan_requests": "Demandes de forfait",
  "req_pending": "En attente",
  "req_approved": "Approuvée",
  "req_rejected": "Refusée",
  "devices_title": "Appareils connectés",
  "this_device": "Cet appareil",
  "remove": "Retirer",
  "last_seen": "Dernière connexion",
  "see_plans": "Voir les forfaits",
  "plan_limit_products": "Limite de produits de votre forfait atteinte. Passez à un forfait supérieur dans Abonnement.",
  "plan_limit_staff": "Limite d'employés de votre forfait atteinte. Passez à un forfait supérieur dans Abonnement.",
  "plan_limit_devices": "Cet appareil dépasse la limite de votre forfait. Retirez un appareil ou changez de forfait.",
  "store_suspended": "Cette boutique est suspendue. Contactez l'administrateur.",
  "apply_plan": "Appliquer le forfait",
  "extend_trial": "Prolonger l'essai (jours)",
  "extend": "Prolonger",
  "suspend_store": "Suspendre la boutique",
  "approve": "Approuver",
  "reject": "Refuser",
  "platform_settings": "Tarifs et paiement",
  "price_pro": "Prix Pro / mois",
  "price_business": "Prix Business / mois",
  "instructions_label": "Instructions de paiement pour les boutiques",
  "no_requests": "Aucune demande",
  "plan_updated": "Forfait mis à jour",
  "pending_requests": "Demandes en attente",
  "install_app": "Installer l'app",
  "install_done": "L'app est déjà installée sur cet appareil",
  "install_desc": "Installez Orbit sur ce PC Windows ou terminal tactile : elle s'ouvre en plein écran depuis une icône, comme une app normale, et fonctionne hors ligne.",
  "install_step1": "Ouvrez cette page dans Google Chrome ou Microsoft Edge.",
  "install_step2": "Cliquez sur l'icône d'installation (écran avec flèche) dans la barre d'adresse, ou sur le menu ⋮ → « Installer Orbit ».",
  "tab_overview": "Résumé",
  "tab_stores": "Boutiques",
  "tab_users": "Utilisateurs",
  "tab_billing": "Forfaits et demandes",
  "tab_admins": "Administrateurs",
  "tab_settings": "Paramètres de la plateforme",
  "search_users": "Rechercher par e-mail, nom ou boutique",
  "disabled_label": "Désactivé",
  "enabled_label": "Actif",
  "disable_login": "Désactiver l'accès",
  "enable_login": "Activer l'accès",
  "reset_password": "Réinitialiser le mot de passe",
  "new_password": "Nouveau mot de passe (min. 8)",
  "password_reset_done": "Mot de passe modifié ; les sessions ouvertes ont été fermées",
  "delete_store": "Supprimer la boutique",
  "delete_store_confirm": "Supprimer « {n} » et toutes ses données ? Cette action est irréversible.",
  "store_deleted": "Boutique supprimée",
  "add_admin": "Ajouter un administrateur",
  "admin_perms_label": "Onglets autorisés",
  "role_superadmin": "Super admin",
  "role_platform_admin": "Administrateur",
  "delete_admin_confirm": "Supprimer cet administrateur ?",
  "admin_saved": "Administrateur enregistré",
  "all_access": "Accès total",
  "edit_btn": "Modifier",
  "del_btn": "Supprimer",
  "created": "Créé",
  "account_disabled": "Ce compte est désactivé. Contactez l'administrateur.",
  "tab_activity": "Journal d'activité",
  "log_search": "Rechercher par administrateur, boutique ou e-mail",
  "log_all_actions": "Toutes les actions",
  "log_empty": "Aucune activité pour le moment",
  "log_from": "Du",
  "log_date": "Date",
  "log_to": "Au",
  "log_action": "Action",
  "log_target": "Cible",
  "log_detail": "Détail",
  "powered_by": "Propulsé par",
  "log_shop.plan": "Forfait modifié",
  "log_shop.trial": "Essai prolongé",
  "log_shop.suspend": "Boutique suspendue",
  "log_shop.unsuspend": "Boutique réactivée",
  "log_shop.delete": "Boutique supprimée",
  "log_request.approve": "Demande approuvée",
  "log_request.reject": "Demande refusée",
  "log_user.disable": "Accès désactivé",
  "log_user.enable": "Accès activé",
  "log_user.password": "Mot de passe du propriétaire modifié",
  "log_admin.create": "Administrateur créé",
  "log_admin.update": "Administrateur modifié",
  "log_admin.password": "Mot de passe admin modifié",
  "log_admin.delete": "Administrateur supprimé",
  "log_settings.update": "Paramètres de la plateforme modifiés",
  "install_step3": "Confirmez avec « Installer ». Une icône apparaîtra sur le bureau et dans le menu Démarrer.",
  "install_step4": "Clic droit sur l'icône de la barre des tâches pour ouvrir directement le Terminal tactile ou Vendre.",
  "install_android": "Android (Chrome) : menu ⋮ → « Installer l'app » ou « Ajouter à l'écran d'accueil ».",
  "install_ios": "iPhone/iPad (Safari) : bouton Partager → « Ajouter à l'écran d'accueil ».",
};
